import BNC_CONSISTENCY_CHECKS_2024 from "./consistencyChecks/2024/BNC_coherence.json";
import RSP_CONSISTENCY_CHECKS_2024 from "./consistencyChecks/2024/RSP_coherence.json";
import RSS_CONSISTENCY_CHECKS_2024 from "./consistencyChecks/2024/RSS_coherence.json";
import RNP_CONSISTENCY_CHECKS_2024 from "./consistencyChecks/2024/RNP_coherence.json";
import RNS_CONSISTENCY_CHECKS_2024 from "./consistencyChecks/2024/RNS_coherence.json";
import BNC_LIST_FORMS_2024 from "./formList/2024/Form_BNC.json";
import BIC_RSS_LIST_FORMS_2024 from "./formList/2024/Form_RSS.json";
import BIC_RNS_LIST_FORMS_2024 from "./formList/2024/Form_RNS.json";
import BIC_RSP_LIST_FORMS_2024 from "./formList/2024/Form_RSP.json";
import BIC_RNP_LIST_FORMS_2024 from "./formList/2024/Form_RNP.json";
import SCI_LIST_FORMS_2024 from "./formList/2024/Form_SCI.json";
import SCI_CORRESPONDENCE_TABLE_2024 from "./utils/2024/SCI.json";
import BNC_PLR_2024 from "../radicalsPlans/2024/PLR_BNC.json";
import BIC_RSS_PLR_2024 from "../radicalsPlans/2024/PLR_RSS.json";
import BIC_RNS_PLR_2024 from "../radicalsPlans/2024/PLR_RNS.json";
import BIC_RSP_PLR_2024 from "../radicalsPlans/2024/PLR_RSP.json";
import BIC_RNP_PLR_2024 from "../radicalsPlans/2024/PLR_RNP.json";
import SCI_PLR_2024 from "../radicalsPlans/2024/PLR_SCI.json";
import SCI_FONC_PLR_2024 from "../radicalsPlans/2024/PLR_SCI_FONC.json";
import RF1_2024 from "./utils/2024/RF1.json";
import RF2_2024 from "./utils/2024/RF2.json";
import RF3_2024 from "./utils/2024/RF3.json";
import RF4_2024 from "./utils/2024/RF4.json";
import RF5_2024 from "./utils/2024/RF5.json";

import BNC_CONSISTENCY_CHECKS_2025 from "./consistencyChecks/2025/BNC_coherence.json";
import RSP_CONSISTENCY_CHECKS_2025 from "./consistencyChecks/2025/RSP_coherence.json";
import RSS_CONSISTENCY_CHECKS_2025 from "./consistencyChecks/2025/RSS_coherence.json";
import RNP_CONSISTENCY_CHECKS_2025 from "./consistencyChecks/2025/RNP_coherence.json";
import RNS_CONSISTENCY_CHECKS_2025 from "./consistencyChecks/2025/RNS_coherence.json";
import BNC_LIST_FORMS_2025 from "./formList/2025/Form_BNC.json";
import BIC_RSS_LIST_FORMS_2025 from "./formList/2025/Form_RSS.json";
import BIC_RNS_LIST_FORMS_2025 from "./formList/2025/Form_RNS.json";
import BIC_RSP_LIST_FORMS_2025 from "./formList/2025/Form_RSP.json";
import BIC_RNP_LIST_FORMS_2025 from "./formList/2025/Form_RNP.json";
import SCI_LIST_FORMS_2025 from "./formList/2025/Form_SCI.json";
import RNA_LIST_FORMS_2025 from "./formList/2025/Form_RNA.json";
import RSA_LIST_FORMS_2025 from "./formList/2025/Form_RSA.json";
import OGBNC_LIST_FORMS from "./formList/2025/Form_OGBNC.json";
import OGBIC_LIST_FORMS from "./formList/2025/Form_OGBIC.json";
import SCI_CORRESPONDENCE_TABLE_2025 from "./utils/2025/SCI.json";
import BNC_PLR_2025 from "../radicalsPlans/2025/PLR_BNC.json";
import BIC_RSS_PLR_2025 from "../radicalsPlans/2025/PLR_RSS.json";
import BIC_RNS_PLR_2025 from "../radicalsPlans/2025/PLR_RNS.json";
import BIC_RSP_PLR_2025 from "../radicalsPlans/2025/PLR_RSP.json";
import BIC_RNP_PLR_2025 from "../radicalsPlans/2025/PLR_RNP.json";
import SCI_PLR_2025 from "../radicalsPlans/2025/PLR_SCI.json";
import SCI_FONC_PLR_2025 from "../radicalsPlans/2025/PLR_SCI_FONC.json";
import RSA_PLR_2025 from "../radicalsPlans/2025/PLR_RSA.json";
import RF1_2025 from "./utils/2025/RF1.json";
import RF2_2025 from "./utils/2025/RF2.json";
import RF3_2025 from "./utils/2025/RF3.json";
import RF4_2025 from "./utils/2025/RF4.json";
import RF5_2025 from "./utils/2025/RF5.json";

import BOOKLET_ANNEXES_LIST_FORMS from "./formList/Form_ANNEXES.json";

import { TaxFormBase } from "../taxform/TaxFormBase";
import { SheetManager } from "../taxform/SheetManager";
import ConsistencyChecksManager from "./consistencyChecks/ConsistencyChecksManager";
import { groupBy } from "lodash";
import { mathFix, isAccountingZero, checkIfCloseToZero } from "../services/mathServices";
import moment from "moment";
import ConsistencyCheck from "./consistencyChecks/ConsistencyCheck";
import SpecValue from "../specs/SpecValue";
import { extractNumberBtqStreet } from "../declaration/declarationServices";
import Spec from "../specs/Spec";

const Company_vatSystem = {
    NotSubjectTo: "NotSubjectTo",
    BelowTheThreshold: "BelowTheThreshold",
    Normal: "Normal",
    Simplified: "Simplified",
    SimplifiedExercise: "SimplifiedExercise",
    Quartely: "Quartely",
    FlatRateRefund: "FlatRateRefund",
};

function isNotSubjectToVAT(vatSystem: string): boolean {
    return (
        vatSystem === Company_vatSystem.NotSubjectTo ||
        vatSystem === Company_vatSystem.BelowTheThreshold
    );
}

export type CompanyIncomeCategory = "ASSOC" | "BA" | "BIC" | "BNC" | "RF";
export type CompanyIncomeTaxRegime =
    | "OTHER"
    | "SELF_EMPLOYED"
    | "CONTROLLED_DECLARATION"
    | "MICRO_BA"
    | "MICRO_ENTERPRISE"
    | "REAL_SIMPLIFIED"
    | "REAL_NORMAL";

export type BundleSettingsVariables = {
    taxSystem?: {
        income: CompanyIncomeCategory;
        regime: CompanyIncomeTaxRegime;
        type: string;
    };
    ogaEnrolmentConfig?: {
        address?: string;
        postalCode?: string;
        city?: string;
        designation?: string;
        numberId?: string;
        siret?: string;
        year?: string;
    };
    ogaEnrolment?: {
        address?: string;
        postalCode?: string;
        city?: string;
        designation?: string;
        numberId?: string;
        siret?: string;
        year?: string;
    };
};

export abstract class BundleBase extends TaxFormBase {
    bundle: any;

    public bundleN1: BundleBase;

    public balances: any = [];

    public settingsVariables: BundleSettingsVariables = {};

    public consistencyChecksManager: ConsistencyChecksManager;

    public bundleSheets: { [key: string]: SheetManager } = {};
    // public multipleBundleSheets: { [key: string]: SheetManager[] } = {};

    // public specs: { [key: string]: Spec } = {};
    public toSendDependencied: { [key: string]: Function[] } = {};

    public radicals: { [k: string]: number } = {};
    public radicalsComposition: {
        [k: string]: { name: string; description: string; balance: number }[];
    } = {};

    public aaClassesBalanceSum: { [k: string]: number } = {};

    public accountingPeriod: any = {};

    public buildingBalances: any = [];

    public loaded: boolean = false;

    public fixedAssets: any = {};

    public fixedAssetsError: boolean = false;
    public fixedAssetsErrorMessage: string = "";

    public fixedVariables: { [key: string]: string | number | boolean };

    public companyDetails: CompanyDetails;

    public extraData: any = [];

    public unaffectedAccounts: any = [];

    public status: string = "EDITION";

    public bookletTemplate: any = null;

    // public generalLedger: any

    public year = `${moment().year()}`;

    bundleSheetsToDelete: string[] = [];

    constructor(
        public bundleId: string,
        public companyId: string,
        public accountingPeriodId: string,
        public userId: string
    ) {
        super();
    }

    showAllConsistencyChecks_: boolean = false;

    associates: any = null;

    legalForm: string = "";

    isBookletTemplatePersonalized: boolean = false;

    importFilesMillesim: string = null;

    static bundleTypeFromTaxSystem(
        incomeCategory: CompanyIncomeCategory,
        taxRegime: CompanyIncomeTaxRegime,
        taxSystemType: string
    ) {
        if (incomeCategory === "BIC" && taxRegime === "REAL_NORMAL") {
            if (taxSystemType === "IS") {
                return "BICRNS";
            }
            if (taxSystemType === "IR") {
                return "BICRNP";
            }
        }
        if (incomeCategory === "BIC" && taxRegime === "REAL_SIMPLIFIED") {
            if (taxSystemType === "IS") {
                return "BICRSS";
            }
            if (taxSystemType === "IR") {
                return "BICRSP";
            }
        }
        if (incomeCategory === "BNC") {
            return "BNC";
        }
        if (incomeCategory === "RF") {
            return "SCI";
        }
        if (incomeCategory === "BA" && taxRegime === "REAL_NORMAL") {
            return "BARNA";
        }
        if (incomeCategory === "BA" && taxRegime === "REAL_SIMPLIFIED") {
            return "BARSA";
        }
        return "";
    }

    static formFiles: Record<string, Record<string, any>> = {
        "2024": {
            BICRSS: BIC_RSS_LIST_FORMS_2024,
            BICRNS: BIC_RNS_LIST_FORMS_2024,
            BICRSP: BIC_RSP_LIST_FORMS_2024,
            BICRNP: BIC_RNP_LIST_FORMS_2024,
            BNC: BNC_LIST_FORMS_2024,
            SCI: SCI_LIST_FORMS_2024,
        },
        "2025": {
            BICRSS: BIC_RSS_LIST_FORMS_2025,
            BICRNS: BIC_RNS_LIST_FORMS_2025,
            BICRSP: BIC_RSP_LIST_FORMS_2025,
            BICRNP: BIC_RNP_LIST_FORMS_2025,
            BNC: BNC_LIST_FORMS_2025,
            SCI: SCI_LIST_FORMS_2025,
            BARNA: RNA_LIST_FORMS_2025,
            BARSA: RSA_LIST_FORMS_2025,
        },
    };

    static listFormFromBundleType(bundleType: string, importFilesMillesim: string): any[] {
        if (!bundleType) {
            return [];
        }
        return this.formFiles[importFilesMillesim]?.[bundleType] ?? [];
    }

    get OGFormList() {
        if (!["BNC", "BICRNP", "BICRSP"].includes(this.bundleType)) {
            return [];
        }
        if (!this.settingsVariables.ogaEnrolment) {
            return [];
        }
        return this.bundleType === "BNC" ? OGBNC_LIST_FORMS : OGBIC_LIST_FORMS;
    }

    get selectors() {
        return this.importFilesMillesim === "2024"
            ? {
                  RF1: RF1_2024,
                  RF2: RF2_2024,
                  RF3: RF3_2024,
                  RF4: RF4_2024,
                  RF5: RF5_2024,
              }
            : {
                  RF1: RF1_2025,
                  RF2: RF2_2025,
                  RF3: RF3_2025,
                  RF4: RF4_2025,
                  RF5: RF5_2025,
              };
    }

    get SCICorrespondenceTable() {
        return this.importFilesMillesim === "2024"
            ? SCI_CORRESPONDENCE_TABLE_2024
            : SCI_CORRESPONDENCE_TABLE_2025;
    }

    get bundleType() {
        return BundleBase.bundleTypeFromTaxSystem(
            this.settingsVariables?.taxSystem?.income,
            this.settingsVariables?.taxSystem?.regime,
            this.settingsVariables?.taxSystem?.type
        );
    }

    get plr() {
        if (!this.bundleType) {
            return [];
        }
        const plrMapping = {
            "2024": {
                BICRSS: BIC_RSS_PLR_2024,
                BICRNS: BIC_RNS_PLR_2024,
                BICRSP: BIC_RSP_PLR_2024,
                BICRNP: BIC_RNP_PLR_2024,
                BNC: BNC_PLR_2024,
                SCI: SCI_PLR_2024,
            },
            "2025": {
                BICRSS: BIC_RSS_PLR_2025,
                BICRNS: BIC_RNS_PLR_2025,
                BICRSP: BIC_RSP_PLR_2025,
                BICRNP: BIC_RNP_PLR_2025,
                BNC: BNC_PLR_2025,
                SCI: SCI_PLR_2025,
                BARSA: RSA_PLR_2025,
            },
        };
        return plrMapping[this.importFilesMillesim]?.[this.bundleType] ?? [];
    }

    getPLR(name: string) {
        const plrMapping = {
            "2024": {
                PLR_RSS: BIC_RSS_PLR_2024,
                PLR_RNS: BIC_RNS_PLR_2024,
                PLR_RSP: BIC_RSP_PLR_2024,
                PLR_RNP: BIC_RNP_PLR_2024,
                PLR_BNC: BNC_PLR_2024,
                PLR_SCI: SCI_PLR_2024,
                PLR_SCI_FONC: SCI_FONC_PLR_2024,
            },
            "2025": {
                PLR_RSS: BIC_RSS_PLR_2025,
                PLR_RNS: BIC_RNS_PLR_2025,
                PLR_RSP: BIC_RSP_PLR_2025,
                PLR_RNP: BIC_RNP_PLR_2025,
                PLR_BNC: BNC_PLR_2025,
                PLR_SCI: SCI_PLR_2025,
                PLR_SCI_FONC: SCI_FONC_PLR_2025,
                PLR_RSA: RSA_PLR_2025,
            },
        };
        return plrMapping[this.importFilesMillesim]?.[name] ?? [undefined];
    }

    get formsList(): any[] {
        if (!this.bundleType) {
            return [];
        }
        return [
            ...BundleBase.listFormFromBundleType(this.bundleType, this.importFilesMillesim),
            ...this.OGFormList,
        ];
    }

    get allForms(): any[] {
        const extractForms = (forms: any[]) => {
            return forms.flatMap((form) => {
                const current = form.cerfa ? [form] : [];
                const complements = form.complementForm
                    ? extractForms(form.complementForm)
                    : form.forms
                    ? extractForms(form.forms)
                    : [];
                return [...current, ...complements];
            });
        };
        return extractForms(this.formsList);
    }

    consistencyChecksFiles: Record<string, Record<string, any>> = {
        "2024": {
            BICRSS: RSS_CONSISTENCY_CHECKS_2024,
            BICRNS: RNS_CONSISTENCY_CHECKS_2024,
            BICRSP: RSP_CONSISTENCY_CHECKS_2024,
            BICRNP: RNP_CONSISTENCY_CHECKS_2024,
            BNC: BNC_CONSISTENCY_CHECKS_2024,
        },
        "2025": {
            BICRSS: RSS_CONSISTENCY_CHECKS_2025,
            BICRNS: RNS_CONSISTENCY_CHECKS_2025,
            BICRSP: RSP_CONSISTENCY_CHECKS_2025,
            BICRNP: RNP_CONSISTENCY_CHECKS_2025,
            BNC: BNC_CONSISTENCY_CHECKS_2025,
        },
    };

    get consistencyChecksList(): any {
        if (!this.bundleType || ["SCI", "BARNA", "BARSA"].includes(this.bundleType)) {
            return {};
        }
        return this.consistencyChecksFiles[this.importFilesMillesim]?.[this.bundleType] ?? {};
    }

    get showAllConsistencyChecks() {
        if (!this.consistencyChecksManager) return true;
        if (this.showAllConsistencyChecks_) return this.showAllConsistencyChecks_;
        return this.consistencyChecksManager.showAllConsistencyChecks;
    }

    set showAllConsistencyChecks(data) {
        this.showAllConsistencyChecks_ = data;
    }

    get allChecksValid() {
        if (!this.consistencyChecksManager) return true;
        return this.consistencyChecksManager.allChecksValid;
    }

    get consistencyChecks(): { [k: string]: ConsistencyCheck } {
        if (!this.consistencyChecksManager) return {};
        const checkKeys = Object.keys(this.consistencyChecksManager.fields);
        let checks = {};
        for (let ck of checkKeys) {
            if (ck.startsWith("check")) {
                const check = this.consistencyChecksManager.fields[ck];
                checks = { ...checks, [ck]: check };
            }
        }
        return checks;
    }

    // get filteredChecks() {
    //     // if (!this.consistencyChecksManager) return {};
    //     // if (!this.showAllConsistencyChecks) {
    //     //     let checksToValidate = {};
    //     //     for (const [key, value] of Object.entries(this.consistencyChecks)) {
    //     //         if (!value.isValid) {
    //     //             checksToValidate[key] = value;
    //     //         }
    //     //     }
    //     //     return checksToValidate;
    //     // }
    //     // return this.consistencyChecks;

    //     return this.consistencyChecksManager.filteredChecks
    // }

    get invalidChecksCount() {
        if (!this.consistencyChecksManager) return 0;
        let count = 0;
        for (const [key, value] of Object.entries(this.consistencyChecks)) {
            if (!value.isValid) {
                count++;
            }
        }
        return count;
    }

    get allDependenciesErrors() {
        const errors: any = [];
        const keys = Object.keys(this.bundleSheets);
        for (const key in this.bundleSheets) {
            // only concerned bundle sheets
            const dependenciesErrors = this.bundleSheets[key].dependenciesErrors?.filter((error) =>
                keys.some((k) => error.field.includes(k))
            );
            // handled in the setPreviousDeficitsCarriedForward function
            const filteredDependenciesErrors = dependenciesErrors.filter(
                (error) => error.field !== "N1CEL:2033D:MH" && error.field !== "N1CEL:2058B:YK"
            );
            if (filteredDependenciesErrors.length) {
                errors.push({
                    cerfa: this.bundleSheets[key].cerfaNumber,
                    errors: dependenciesErrors,
                });
            }
        }
        return errors;
    }

    get bookletTemplateId() {
        return this.bookletTemplate?.id || null;
    }

    set bookletTemplateId(id) {
        this.bookletTemplate["id"] = id;
    }

    abstract getBundleQuery();

    abstract getBundleSheetQuery(bundleSheetId: string);

    abstract getGeneralLedgerQuery();

    abstract getFixedAssetsQuery();

    abstract getExtraDataQuery();

    abstract deleteBundleSheetQuery(bundleSheetId: string);

    abstract saveBundleQuery();

    abstract getDeclarationFormQuery({ year, cerfa });
    abstract getDeclarationFormsQuery({ year, cerfas });

    abstract getBookletTemplatesQuery();

    abstract getBuildings();

    abstract getCompanyInfosQuery();

    abstract getAccountingPeriodQuery();

    abstract getAccountingFirmsOfCompanyQuery();

    abstract getCompanyDetailsQuery();

    abstract getSettingsVariablesQuery();

    async getBundle() {
        try {
            await this.getBundleQuery();
            if (this.bundle) {
                if (this.bundle.data) {
                    this.fixedVariables = this.bundle.data.fixedVariables;
                    this.balances = this.bundle.data.balances || this.bundle.data.generalLedger;
                    this.buildingBalances = this.bundle.data.buildingBalances;
                    this.computeBundleN1Balances();
                } else {
                    debugger;
                }
                this.bookletTemplate = this.bundle.bookletTemplate;
                this.status = this.bundle.status;
            }
        } catch (error) {
            console.error("Error getting bundle", error);
            return null;
        }
    }

    setImportFilesMillesim() {
        this.importFilesMillesim = getImportFilesMillesim(
            this.bundle?.bundleSheets?.[0]?.form?.year
        );
        if (this.bundleN1) {
            this.bundleN1.importFilesMillesim = this.importFilesMillesim;
        }
    }

    async afterInstanciate() {
        await this.getAccountingPeriod();
        await this.getSettingsVariables(); // n1 too
        await this.getBundle();
        this.setImportFilesMillesim(); // n1 too
        await this.getBalances(); // n1 too
        this.onUpdateBalances(); // n1 too
        await this.generateSheets(); // n1 too
        await this.loadAnnexes(false); // n1 too
        this.setFixedVariables(this.fixedVariables); // n1 too
        await this.getCompanyDetails();
        await this.getFixedAssets();
        await this.getAssociates();
        await this.getExtraData();
        await this.setSCIBuildings();
        await this.setHeadOffice();
        await this.setAccountant();
        await this.setCompanyActivities();
        await this.setProfession();
        await this.setOGAEnrolment();
        await this.setAccountingPeriodCVAE();
        await this.setLegalForm();
        await this.setBusinessStartDate();
        await this.setSubjectToTVA();
        await this.setOGBNCVat();
        await this.setCompanyAssociates();
        await this.setCompanyAssociatesSCI();
        await this.setOGA();
        // await this.checkIfAllMandatoryPagesAreReferenced(); // SEE IF USELESS
        this.generateConsistencyChecks();
        this.updateDependencies(); // n1 too
        this.update(); // n1 too
        this.loaded = true;
        return this;
    }

    async getReadOnlyBundleSheet(bundleSheetId): Promise<SheetManager> {
        try {
            const bundleSheet = await this.getBundleSheetQuery(bundleSheetId);
            const declarationForm = await this.getDeclarationForm({
                year: bundleSheet.form.year,
                cerfa: bundleSheet.form.form.form.name,
            });
            if (!declarationForm) {
                console.error({
                    type: "error",
                    message: `No declaration form found for ${bundleSheet.form.cerfa} in ${bundleSheet.form.year}`,
                });
                return;
            }
            return new SheetManager(
                bundleSheet.id,
                declarationForm,
                {},
                null,
                null,
                true,
                bundleSheet.data
            );
        } catch (error) {
            console.error("Error getting bundle", error);
            return null;
        }
        //
    }

    async getFixedAssets() {
        if (!this.isSent || !this.bundleId?.length || !this.accountingPeriod?.closed) {
            const fixedAssets = await this.getFixedAssetsQuery();
            if (fixedAssets?.error?.error) {
                this.fixedAssets = fixedAssets;
                this.fixedAssetsError = true;
                this.fixedAssetsErrorMessage = fixedAssets.error.error;
            } else if (fixedAssets?.formatedFixedAssets?.length) {
                this.fixedAssets = fixedAssets;
                await this.setFixedAssets();
                this.update();
            }
        }
    }

    async getAccountingPeriod() {
        const accountingPeriod = await this.getAccountingPeriodQuery();
        this.accountingPeriod = accountingPeriod;
    }

    async getAssociates() {
        try {
            const infos = await this.getCompanyInfosQuery();
            this.associates = infos;
        } catch (error) {
            console.error("Error getting associates", error);
        }
    }

    async getBalances() {
        if (!this.balances.length) {
            const generalLedger = await this.getGeneralLedgerQuery();
            if (!generalLedger?.balances?.length) {
                debugger;
                this.balances = [];
                return;
            }

            this.balances = generalLedger.balances;
            this.buildingBalances = generalLedger.buildingBalances;
            this.computeBundleN1Balances();
        }

        return this.balances;
    }

    computeBundleN1Balances() {
        if (this.bundleN1) {
            const balancesN1 = this.balances.map((aa) => ({
                ...aa,
                balance: aa.previousBalance,
                debit: aa.previousBalance > 0 ? aa.previousBalance : 0,
                credit: aa.previousBalance < 0 ? -aa.previousBalance : 0,
            }));
            this.bundleN1.balances = balancesN1;
        }
    }

    setValue(bundleSheet: SheetManager, valueKey: string, value: string | number | boolean) {
        if (bundleSheet) {
            let foundSpec = bundleSheet.specs.find((spec) => spec.key === valueKey);
            if (foundSpec) {
                // const index = bundleSheet.specs.indexOf(foundSpec)
                // bundleSheet.specs[index].readonly = false
                // bundleSheet.specs[index].setStream({userValue: value})
                // bundleSheet.fields[valueKey].readonly = false
                // bundleSheet.fields[valueKey].setStream({userValue: value})
            } else {
                foundSpec = new SpecValue(valueKey, bundleSheet, true);
                bundleSheet.addExternalFields(valueKey, foundSpec);
            }
            foundSpec.forceUserValue(value);
        } else {
        }
    }

    async getExtraData() {
        if (!this.bundleId) {
            const extraData = await this.getExtraDataQuery();
            if (extraData) {
                this.setExtraData(extraData);
                this.update();
            }
        }
    }

    setExtraData(extraData) {
        if (!extraData.length) return;
        this.extraData = extraData;
        for (const cerfaData of extraData) {
            const bundleSheet = this.bundleSheets[cerfaData.cerfa];
            if (bundleSheet) {
                for (const valueKey in cerfaData.values) {
                    this.setValue(bundleSheet, valueKey, cerfaData.values[valueKey]);
                }
            } else {
                console.error("setExtraData => bundleSheet not found for", cerfaData.cerfa);
            }
        }
    }

    setFixedVariables(fixedVariables: { [key: string]: string | number | boolean }) {
        if (this.bundleN1) {
            this.bundleN1.setFixedVariables(fixedVariables);
        }
        if (!fixedVariables) {
            fixedVariables = {};
            // we need it on backend too
            fixedVariables.D1 = this.getD1FixedVariable();
        }
        if (!Object.entries(fixedVariables)?.length) return;
        this.fixedVariables = fixedVariables;
        const bundleSheetsList = Object.keys(this.bundleSheets);
        for (const [key, value] of Object.entries(fixedVariables)) {
            for (const sheet of bundleSheetsList) {
                const bundleSheet = this.bundleSheets[sheet];
                this.setValue(bundleSheet, key, value);
            }
        }
    }

    getD1FixedVariable(): number {
        // In practice, the maximum amount of profit eligible for the reduced corporate tax rate for a fiscal year
        // lasting less than twelve months is determined by applying a coefficient to the amount of €42,500.
        // This coefficient is equal to the ratio between the number of months included in the fiscal year and 12.
        // If the fiscal year begins or ends in the middle of a calendar month, the remaining days are taken into
        // account to determine the ratio, based on the proportion of those days to 30.

        if (!this.accountingPeriod?.start || !this.accountingPeriod?.end) {
            return 1;
        }

        function addDays(date: Date, days: number): Date {
            const newDate = new Date(date);
            newDate.setDate(newDate.getDate() + days);
            return newDate;
        }

        function getMonthEndDate(date: Date): Date {
            return new Date(date.getFullYear(), date.getMonth() + 1, 0);
        }

        function getNextMonthStartDate(date: Date): Date {
            return new Date(date.getFullYear(), date.getMonth() + 1, 1);
        }

        const startDate: Date = new Date(this.accountingPeriod.start);
        const endDate: Date = new Date(this.accountingPeriod.end);
        let totalMonths: number = 0;

        // step 1: handle the first month
        if (startDate.getDate() !== 1) {
            const elapsedDays: number = 30 - startDate.getDate() + 1;
            const prorataFirstMonth: number = elapsedDays / 30;
            totalMonths += prorataFirstMonth;
        } else {
            totalMonths += 1;
        }

        // step 2: count the full months between the start and end date
        let nextMonthStartDate: Date = getNextMonthStartDate(startDate);
        while (nextMonthStartDate <= endDate) {
            const currentMonthEndDate: Date = getMonthEndDate(nextMonthStartDate);
            if (currentMonthEndDate <= endDate) {
                totalMonths += 1;
            }
            nextMonthStartDate = addDays(currentMonthEndDate, 1);
        }

        // step 3: handle the last month (if incomplete)
        const lastMonthEndDate: Date = getMonthEndDate(endDate);
        if (endDate.getDate() < lastMonthEndDate.getDate()) {
            const remainingDays: number = 30 - endDate.getDate();
            const prorataLastMonth: number = remainingDays / 30;
            totalMonths += prorataLastMonth;
        }

        if (typeof totalMonths === "number") {
            return totalMonths / 12;
        }
        return 1;
    }

    async getCompanyDetails() {
        this.companyDetails = await this.getCompanyDetailsQuery();
    }

    // async deleteBundleSheet(bundleSheetId: string) {
    //     if (this.bundleId) {
    //         this.bundleSheetsToDelete.push(bundleSheetId)
    //     } else {
    //         await this.deleteBundleSheetQuery(bundleSheetId)
    //     }
    // }

    async saveBundle() {
        if (!this.accountingPeriodId) {
            debugger;
            return;
        }
        const bundle = await this.saveBundleQuery();
        if (!this.bundleId || this.isBookletTemplatePersonalized) {
            if (bundle?.id) {
                this.bundleId = bundle.id;
            }
        }
        let index = 0;
        for (const key in this.bundleSheets) {
            const bundleSheet = this.bundleSheets[key];
            if (bundleSheet) {
                const dbBundleSheet = bundle.bundleSheets[index];
                if (bundleSheet.cerfaNumber !== dbBundleSheet.form?.cerfaNumber) {
                    console.error(
                        "cerfaNumber is different ",
                        bundleSheet.cerfaNumber,
                        "db ",
                        dbBundleSheet.form?.cerfaNumber
                    );
                }
                if (!bundleSheet.id) {
                    if (dbBundleSheet.id) {
                        bundleSheet.id = dbBundleSheet.id;
                    } else {
                    }
                } else if (bundleSheet.id !== dbBundleSheet.id) {
                    console.error("id are different ", bundleSheet.id, "db ", dbBundleSheet.id);
                }
            }
            index++;
        }
        //
        // Delete bundSheet corresponding to removed bookletTemplate form
        // TO DO : Romain
        //
        //     if (this.bundleSheetsToDelete?.length) {
        //         let bundleSheetsToDeletePromises = []
        //         for (const bsId of this.bundleSheetsToDelete) {
        //             bundleSheetsToDeletePromises.push(
        //                 this.deleteBundleSheetQuery(bsId)
        //             )
        //         }
        //         await Promise.all(bundleSheetsToDeletePromises)
        //     }

        return this.bundleId;
    }

    async setFixedAssets() {
        if (this.fixedAssets?.formatedFixedAssets?.length) {
            if (this.bundleType === "BNC") {
                await this.setBNCFixedAssets();
            } else if (this.bundleType.startsWith("BIC")) {
                await this.setBICFixedAssets(this.accountingPeriodId);
            }
        }
    }

    async setBNCFixedAssets() {
        if (this.fixedAssets?.formatedFixedAssets?.length) {
            let currentForm = "2035SA";
            let index = 0;
            for (const fixedAsset of this.fixedAssets.formatedFixedAssets) {
                let keyExtension = "";

                if (index < 1) {
                    keyExtension = "";
                } else if (index < 9) {
                    const extension = `${index + 1}`;
                    keyExtension = `_${extension.padStart(2, "0")}`;
                } else {
                    keyExtension = `_${index + 1}`;
                }

                if (!this.bundleSheets[currentForm]?.fields[`BA${keyExtension}`]) {
                    currentForm = (await this.createAdditionalPage("2035S1E2")).name;
                    index = 0;
                    keyExtension = "";
                }

                this.bundleSheets[currentForm].fields[`BA${keyExtension}`].value =
                    fixedAsset.nature;
                this.bundleSheets[currentForm].fields[`BK${keyExtension}`].value = moment(
                    fixedAsset.acquisitionDate
                ).format("DD/MM/YYYY");
                this.bundleSheets[currentForm].fields[`BU${keyExtension}`].value =
                    fixedAsset.grossAmount;
                this.bundleSheets[currentForm].fields[`CD${keyExtension}`].value =
                    fixedAsset.vatAmount;
                this.bundleSheets[currentForm].fields[`CN${keyExtension}`].value =
                    fixedAsset.netAmount;
                this.bundleSheets[currentForm].fields[`KC${keyExtension}`].value =
                    fixedAsset.type !== "N/A" ? fixedAsset.type : "";
                this.bundleSheets[currentForm].fields[`CX${keyExtension}`].value = fixedAsset.rate;
                this.bundleSheets[currentForm].fields[`DG${keyExtension}`].value =
                    fixedAsset.previousDepreciations;
                this.bundleSheets[currentForm].fields[`DR${keyExtension}`].value =
                    fixedAsset.currentDepreciation;

                index++;
            }
        }
    }

    // "BICRNS" | "BICRNP" | "BICRSS" | "BICRSP" | "BNC" | "SCI"

    // ++ 2033C - BICRSP + BICRSS     BIC soumis à l'IS - régime Réel simplifié RSS
    // ** IMMOS
    aasKeysDico2033C_immos = {
        "206": {
            previous: "AA",
            increase: "BA",
            decrease: "CA",
        },
        "207": {
            previous: "AA",
            increase: "BA",
            decrease: "CA",
        },
        "109": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "200": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "201": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "203": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "205": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "208": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "237": {
            previous: "AB",
            increase: "BB",
            decrease: "CB",
        },
        "211": {
            previous: "AC",
            increase: "BC",
            decrease: "CC",
        },
        "212": {
            previous: "AC",
            increase: "BC",
            decrease: "CC",
        },
        "2135": {
            previous: "AD",
            increase: "BD",
            decrease: "CD",
        },
        "213": {
            previous: "AD",
            increase: "BD",
            decrease: "CD",
        },
        "214": {
            previous: "AD",
            increase: "BD",
            decrease: "CD",
        },
        "215": {
            previous: "AE",
            increase: "BE",
            decrease: "CE",
        },
        "2181": {
            previous: "AF",
            increase: "BF",
            decrease: "CF",
        },
        "2182": {
            previous: "AG",
            increase: "BG",
            decrease: "CG",
        },
        "2180": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "2183": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "2184": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "2186": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "231": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "232": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "238": {
            previous: "AH",
            increase: "BH",
            decrease: "CH",
        },
        "267": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "268": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "26": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "271": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "272": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "274": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "275": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
        "276": {
            previous: "AJ",
            increase: "BJ",
            decrease: "CJ",
        },
    };

    fixedAssetsPreviousAmounts2033C_immos = {
        AA: 0,
        AB: 0,
        AC: 0,
        AD: 0,
        AE: 0,
        AF: 0,
        AG: 0,
        AH: 0,
        AJ: 0,
    };

    fixedAssetsIncreaseAmounts2033C_immos = {
        BA: 0,
        BB: 0,
        BC: 0,
        BD: 0,
        BE: 0,
        BF: 0,
        BG: 0,
        BH: 0,
        BJ: 0,
    };

    fixedAssetsDecreaseAmounts2033C_immos = {
        CA: 0,
        CB: 0,
        CC: 0,
        CD: 0,
        CE: 0,
        CF: 0,
        CG: 0,
        CH: 0,
        CJ: 0,
    };

    // ** AMOS
    aasKeysDico2033C_amos = {
        "206": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "207": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "109": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "200": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "201": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "203": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "205": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "208": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "237": {
            previous: "FA",
            increase: "GA",
            decrease: "HA",
        },
        "211": {
            previous: "FB",
            increase: "GB",
            decrease: "HB",
        },
        "212": {
            previous: "FB",
            increase: "GB",
            decrease: "HB",
        },
        "2135": {
            previous: "FC",
            increase: "GC",
            decrease: "HC",
        },
        "213": {
            previous: "FC",
            increase: "GC",
            decrease: "HC",
        },
        "214": {
            previous: "FC",
            increase: "GC",
            decrease: "HC",
        },
        "215": {
            previous: "FD",
            increase: "GD",
            decrease: "HD",
        },
        "2181": {
            previous: "FE",
            increase: "GE",
            decrease: "HE",
        },
        "2182": {
            previous: "FF",
            increase: "GF",
            decrease: "HF",
        },
        "2180": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "2183": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "2184": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "2186": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "231": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "232": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "238": {
            previous: "FG",
            increase: "GG",
            decrease: "HG",
        },
        "267": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "268": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "26": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "271": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "272": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "274": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "275": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
        "276": {
            previous: "AL",
            increase: "AM",
            decrease: "AN",
        },
    };

    depreciationsPreviousAmounts2033C = {
        AL: 0,
        FA: 0,
        FB: 0,
        FC: 0,
        FD: 0,
        FE: 0,
        FF: 0,
        FG: 0,
    };

    depreciationsIncreaseAmounts2033C = {
        AM: 0,
        GA: 0,
        GB: 0,
        GC: 0,
        GD: 0,
        GE: 0,
        GF: 0,
        GG: 0,
    };

    depreciationsDecreaseAmounts2033C = {
        AN: 0,
        HA: 0,
        HB: 0,
        HC: 0,
        HD: 0,
        HE: 0,
        HF: 0,
        HG: 0,
    };

    // ++ 2054 2055 - BICRNS + BICRNP     BIC soumis à l'IS - régime Réel normal RNS
    // ** 2054 Immobilisations
    aasKeysDico2054 = {
        // ** OK
        // "109": {
        //     previous: "AB",
        //     increase: "BB",
        //     decrease: "CB"
        // },
        // ++ Frais d'établissement et de développement
        "200": {
            // ** Autres immobilisations incorporelles
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        "201": {
            // ** Frais d'établissement
            previous: "RT",
            increase: "RV",
            decrease: "RX",
        },
        "203": {
            // ** Frais de recherche et de développement
            previous: "RT",
            increase: "RV",
            decrease: "RX",
        },
        // ++ Autres postes
        "205": {
            // ** Concession, brevets, licences, marques, procédés, logiciels, droits et valeurs similaires
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        "206": {
            // ** droit au bail
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        "207": {
            // ** fonds commercial
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        "208": {
            // ** Autres immobilisations incorporelles
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        "232": {
            // ** Immobilisations incorporelles en cours
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        "237": {
            // ** Avances et acomptes versés sur commandes d'immobilisations incorporelles
            previous: "KD",
            increase: "KF",
            decrease: "LV",
        },
        // ++ TERRAINS
        "211": {
            // ** Terrains
            previous: "KG",
            increase: "KI",
            decrease: "LX",
        },
        "212": {
            // ** Agencements et aménagements des terrains
            previous: "KG",
            increase: "KI",
            decrease: "LX",
        },
        "213": {
            // ++ Constructions - sur sol propre
            previous: "KJ",
            increase: "KL",
            decrease: "MA",
            exclude: ["2135"], // // exclude
        },
        "214": {
            // ++ Constructions - sur sol d'autrui
            previous: "KM",
            increase: "KO",
            decrease: "MD",
        },
        "2135": {
            // ++ Constructions - Installations générales - agencements - aménagements des constructions
            previous: "KP",
            increase: "KR",
            decrease: "MG",
        },

        "215": {
            // ++ Installations techniques, matériel et outillage industriels
            previous: "KS",
            increase: "KU",
            decrease: "MJ",
        },
        // ++ Autres - Installations générales, agencements, aménagements divers
        "2180": {
            // ** Autres immobilisations corporelles --- COMPTE RACINE ---
            previous: "KV",
            increase: "KX",
            decrease: "MM",
        },
        "2181": {
            // ** Installations générales, agencements, aménagements divers
            previous: "KV",
            increase: "KX",
            decrease: "MM",
        },
        "2182": {
            // ++ Autres - Matériel de transport
            previous: "KY",
            increase: "LA",
            decrease: "MP",
        },
        // ++ Autres - matériel de bureau et mobilier informatique
        "2183": {
            // ** Matériel de bureau et matériel informatique
            previous: "LB",
            increase: "LD",
            decrease: "MS",
        },
        "2184": {
            // ** Mobilier
            previous: "LB",
            increase: "LD",
            decrease: "MS",
        },
        // // not used
        // "2185": { // ++ Autres - Cheptel
        //     previous: "AH",
        //     increase: "BH",
        //     decrease: "CH"
        // },
        "2186": {
            // ++ Autres - Emaballages récupérables
            previous: "LE",
            increase: "LG",
            decrease: "MV",
        },
        // "22": { // ++ Immobilisations mises en concession
        //     previous: "LK",
        //     increase: "LM",
        //     decrease: "ND"
        // },
        "231": {
            // ++ Immobilisations corporelles en cours
            previous: "LH",
            increase: "LJ",
            decrease: "MZ",
        },
        "238": {
            // ** Avances et acomptes versés sur commandes d'immobilisations corporelles
            previous: "LK",
            increase: "LM",
            decrease: "ND",
        },
        "26": {
            // ++ Autres participations
            previous: "PD",
            increase: "PF",
            decrease: "QV",
        },
        // ++ autres titres immobilisés
        "271": {
            // ** Titres immobilisés autres que les titres immobilisés de l'activité de portefeuille
            previous: "PG",
            increase: "PJ",
            decrease: "QZ",
        },
        "272": {
            // ** Titres immobilisés
            previous: "PG",
            increase: "PJ",
            decrease: "QZ",
        },
        "273": {
            // ** Titres immobilisés de l'activité de portefeuille
            previous: "PG",
            increase: "PJ",
            decrease: "QZ",
        },
        // ++ Prêts et autres immobilisations financières
        "25": {
            // ** Participations évaluées par mise en équivalence
            previous: "PA",
            increase: "PC",
            decrease: "QR",
        },
        "274": {
            // ** Prêts
            previous: "PK",
            increase: "PM",
            decrease: "RD",
        },
        "275": {
            // ** Dépôts et cautionnements versés
            previous: "PK",
            increase: "PM",
            decrease: "RD",
        },
        "276": {
            // ** Autres créances immobilisées
            previous: "PK",
            increase: "PM",
            decrease: "RD",
        },
    };

    fixedAssetsPreviousAmounts2054 = {
        // ** OK
        RT: 0,
        KD: 0,
        KG: 0,
        KJ: 0,
        KM: 0,
        KP: 0,
        KS: 0,
        KV: 0,
        KY: 0,
        LB: 0,
        LE: 0,
        LH: 0,
        LK: 0,
        PA: 0,
        PD: 0,
        PG: 0,
        PK: 0,
    };

    fixedAssetsIncreaseAmounts2054 = {
        // ** OK
        RV: 0,
        KF: 0,
        KI: 0,
        KL: 0,
        KO: 0,
        KR: 0,
        KU: 0,
        KX: 0,
        LA: 0,
        LD: 0,
        LG: 0,
        LJ: 0,
        LM: 0,
        PC: 0,
        PF: 0,
        PJ: 0,
        PM: 0,
    };

    fixedAssetsDecreaseAmounts2054 = {
        // ** OK
        RX: 0,
        LV: 0,
        LX: 0,
        MA: 0,
        MD: 0,
        MG: 0,
        MJ: 0,
        MM: 0,
        MP: 0,
        MS: 0,
        MV: 0,
        MZ: 0,
        ND: 0,
        QR: 0,
        QV: 0,
        QZ: 0,
        RD: 0,
    };

    // ** 2055 Amortissements
    aasKeysDico2055 = {
        // ** OK
        // "109": {
        //     previous: "AB",
        //     increase: "BB",
        //     decrease: "CB"
        // },
        // ++ Frais d'établissement et de développement
        "201": {
            // ** Frais d'établissement
            previous: "UR",
            increase: "US",
            decrease: "UT",
        },
        "203": {
            // ** Frais de recherche et de développement
            previous: "UR",
            increase: "US",
            decrease: "UT",
        },
        // ++ fonds commercial
        "207": {
            previous: "AA",
            increase: "AB",
            decrease: "AC",
        },
        // ++ Autres immobilisations incorporelles
        "200": {
            // ** Autres immobilisations incorporelles - compte racine
            previous: "PE",
            increase: "PF",
            decrease: "PG",
        },
        "205": {
            // ** Concession, brevets, licences, marques, procédés, logiciels, droits et valeurs similaires
            previous: "PE",
            increase: "PF",
            decrease: "PG",
        },
        "206": {
            // ** droit au bail
            previous: "PE",
            increase: "PF",
            decrease: "PG",
        },

        "208": {
            // ** Autres immobilisations incorporelles
            previous: "PE",
            increase: "PF",
            decrease: "PG",
        },
        // ++ TERRAINS
        "211": {
            // ** Terrains
            previous: "PI",
            increase: "PJ",
            decrease: "PK",
        },
        "212": {
            // ** Agencements et aménagements des terrains
            previous: "PI",
            increase: "PJ",
            decrease: "PK",
        },
        "213": {
            // ++ Constructions - sur sol propre
            previous: "PM",
            increase: "PN",
            decrease: "PO",
            exclude: ["2135"], // // exclude
        },
        "214": {
            // ++ Constructions - sur sol d'autrui
            previous: "PR",
            increase: "PS",
            decrease: "PT",
        },
        "2135": {
            // ++ Constructions - Installations générales - agencements - aménagements
            previous: "PV",
            increase: "PW",
            decrease: "PX",
        },

        "215": {
            // ++ Installations techniques, matériel et outillage industriels
            previous: "PZ",
            increase: "QA",
            decrease: "QB",
        },
        // ++ Autres - Installations générales, agencements, aménagements divers
        "2180": {
            // ** Autres immobilisations corporelles --- COMPTE RACINE ---
            previous: "QD",
            increase: "QE",
            decrease: "QF",
        },
        "2181": {
            // ** Installations générales, agencements, aménagements divers
            previous: "QD",
            increase: "QE",
            decrease: "QF",
        },
        "2182": {
            // ++ Autres - Matériel de transport
            previous: "QH",
            increase: "QI",
            decrease: "QJ",
        },
        // ++ Autres - matériel de bureau et mobilier informatique
        "2183": {
            // ** Matériel de bureau et matériel informatique
            previous: "QL",
            increase: "QM",
            decrease: "QN",
        },
        "2184": {
            // ** Mobilier
            previous: "QL",
            increase: "QM",
            decrease: "QN",
        },
        // // not used
        // "2185": { // ++ Autres - Cheptel
        //     previous: "AH",
        //     increase: "BH",
        //     decrease: "CH"
        // },
        "2186": {
            // ++ Autres - Emaballages récupérables
            previous: "QP",
            increase: "QQ",
            decrease: "QS",
        },
    };

    depreciationsPreviousAmounts2055 = {
        // ** OK
        UR: 0,
        AA: 0,
        PE: 0,
        PI: 0,
        PM: 0,
        PR: 0,
        PV: 0,
        PZ: 0,
        QD: 0,
        QH: 0,
        QL: 0,
        QP: 0,
    };

    depreciationsIncreaseAmounts2055 = {
        // ** OK
        US: 0,
        AB: 0,
        PF: 0,
        PJ: 0,
        PN: 0,
        PS: 0,
        PW: 0,
        QA: 0,
        QE: 0,
        QI: 0,
        QM: 0,
        QQ: 0,
    };

    depreciationsDecreaseAmounts2055 = {
        // ** OK
        UT: 0,
        AC: 0,
        PG: 0,
        PK: 0,
        PO: 0,
        PT: 0,
        PX: 0,
        QB: 0,
        QF: 0,
        QJ: 0,
        QN: 0,
        QS: 0,
    };

    isDateInAccountingPeriod(date, accountingPeriod) {
        if (
            moment(date).isSameOrAfter(accountingPeriod.start) &&
            moment(date).isSameOrBefore(accountingPeriod.end)
        ) {
            return true;
        }
        return false;
    }

    async setBICFixedAssets(accountingPeriodId) {
        const accountingPeriod = await this.getAccountingPeriodQuery();
        let fixedAssetsAasKeysDico = {};
        let fixedAssetsPreviousAmounts = {};
        let fixedAssetsIncreaseAmounts = {};
        let fixedAssetsDecreaseAmounts = {};

        let depreciationsAssKeyDico = {};
        let depreciationsPreviousAmounts = {};
        let depreciationsIncreaseAmounts = {};
        let depreciationsDecreaseAmounts = {};

        if (this.bundleType === "BICRNP" || this.bundleType === "BICRNS") {
            fixedAssetsAasKeysDico = this.aasKeysDico2054;
            fixedAssetsPreviousAmounts = this.fixedAssetsPreviousAmounts2054;
            fixedAssetsIncreaseAmounts = this.fixedAssetsIncreaseAmounts2054;
            fixedAssetsDecreaseAmounts = this.fixedAssetsDecreaseAmounts2054;

            depreciationsAssKeyDico = this.aasKeysDico2055;
            depreciationsPreviousAmounts = this.depreciationsPreviousAmounts2055;
            depreciationsIncreaseAmounts = this.depreciationsIncreaseAmounts2055;
            depreciationsDecreaseAmounts = this.depreciationsDecreaseAmounts2055;
        } else if (this.bundleType === "BICRSP" || this.bundleType === "BICRSS") {
            fixedAssetsAasKeysDico = this.aasKeysDico2033C_immos;
            fixedAssetsPreviousAmounts = this.fixedAssetsPreviousAmounts2033C_immos;
            fixedAssetsIncreaseAmounts = this.fixedAssetsIncreaseAmounts2033C_immos;
            fixedAssetsDecreaseAmounts = this.fixedAssetsDecreaseAmounts2033C_immos;

            depreciationsAssKeyDico = this.aasKeysDico2033C_amos;
            depreciationsPreviousAmounts = this.depreciationsPreviousAmounts2033C;
            depreciationsIncreaseAmounts = this.depreciationsIncreaseAmounts2033C;
            depreciationsDecreaseAmounts = this.depreciationsDecreaseAmounts2033C;
        }

        for (const fixedAsset of this.fixedAssets.formatedFixedAssets) {
            for (const key in fixedAssetsAasKeysDico) {
                let condition = fixedAsset.accountableAccount.startsWith(key);
                if (fixedAssetsAasKeysDico[key]?.exclude?.length) {
                    if (fixedAssetsAasKeysDico[key]?.exclude?.length === 1) {
                        const excludedAccountRoot = fixedAssetsAasKeysDico[key].exclude[0];
                        condition =
                            fixedAsset.accountableAccount.startsWith(key) &&
                            !fixedAsset.accountableAccount.startsWith(excludedAccountRoot);
                        // debugger;
                    } else {
                        debugger;
                    }
                }
                if (condition) {
                    // debugger
                    // if (!this.bundleN1) {
                    //     const cell = fixedAssetsAasKeysDico[key].increase
                    //     fixedAssetsIncreaseAmounts[cell] += fixedAsset.netAmount
                    // }
                    if (fixedAsset.acquisitionDate) {
                        if (
                            this.isDateInAccountingPeriod(
                                fixedAsset.acquisitionDate,
                                accountingPeriod
                            )
                        ) {
                            const increaseKey = fixedAssetsAasKeysDico[key].increase;
                            fixedAssetsIncreaseAmounts[increaseKey] += fixedAsset.netAmount;
                        } else {
                            const previousKey = fixedAssetsAasKeysDico[key].previous;
                            fixedAssetsPreviousAmounts[previousKey] += fixedAsset.netAmount;
                        }
                    } else {
                        console.error(
                            "🚀 - setBICFixedAssets - fixedAsset.acquisitionDate is missing"
                        );
                        debugger;
                    }

                    if (
                        fixedAsset.outflowDate &&
                        this.isDateInAccountingPeriod(fixedAsset.outflowDate, accountingPeriod)
                    ) {
                        const decreaseKey = fixedAssetsAasKeysDico[key].decrease;
                        fixedAssetsDecreaseAmounts[decreaseKey] += fixedAsset.netAmount;

                        // // to use
                    }

                    break;
                }
            }

            if (this.bundleType.startsWith("BIC")) {
                for (const key in depreciationsAssKeyDico) {
                    if (fixedAsset.accountableAccount.startsWith(key)) {
                        const previousDepreciations = fixedAsset.previousDepreciations || 0;
                        const previousKey = depreciationsAssKeyDico[key].previous;
                        depreciationsPreviousAmounts[previousKey] += previousDepreciations;

                        const currentDepreciation = fixedAsset.currentDepreciation || 0;
                        const increaseKey = depreciationsAssKeyDico[key].increase;
                        depreciationsIncreaseAmounts[increaseKey] += currentDepreciation;

                        if (
                            fixedAsset.outflowDate &&
                            this.isDateInAccountingPeriod(fixedAsset.outflowDate, accountingPeriod)
                        ) {
                            const decreaseKey = depreciationsAssKeyDico[key].decrease;

                            const outflowReversal = previousDepreciations + currentDepreciation;
                            depreciationsDecreaseAmounts[decreaseKey] += outflowReversal || 0;
                        }
                    }
                }
            }
        }

        if (this.bundleSheets["2054"]) {
            const bundleSheet = this.bundleSheets["2054"];

            for (const key in fixedAssetsPreviousAmounts) {
                if (fixedAssetsPreviousAmounts[key] !== 0) {
                    const innerValue = fixedAssetsPreviousAmounts[key];
                    bundleSheet.fields[key].forceUserValue(innerValue);
                }
            }

            for (const key2 in fixedAssetsIncreaseAmounts) {
                if (fixedAssetsIncreaseAmounts[key2] !== 0) {
                    const innerValue2 = fixedAssetsIncreaseAmounts[key2];
                    bundleSheet.fields[key2].forceUserValue(innerValue2);
                }
            }

            for (const key3 in fixedAssetsDecreaseAmounts) {
                if (fixedAssetsDecreaseAmounts[key3] !== 0) {
                    const innerValue3 = fixedAssetsDecreaseAmounts[key3];
                    bundleSheet.fields[key3].forceUserValue(innerValue3);
                }
            }
        }

        if (this.bundleSheets["2055"]) {
            const bundleSheet = this.bundleSheets["2055"];

            for (const key in depreciationsPreviousAmounts) {
                if (depreciationsPreviousAmounts[key] !== 0) {
                    const innerValue = depreciationsPreviousAmounts[key];
                    bundleSheet.fields[key].forceUserValue(innerValue);
                }
            }

            for (const key2 in depreciationsIncreaseAmounts) {
                if (depreciationsIncreaseAmounts[key2] !== 0) {
                    const innerValue2 = depreciationsIncreaseAmounts[key2];
                    bundleSheet.fields[key2].forceUserValue(innerValue2);
                }
            }

            for (const key3 in depreciationsDecreaseAmounts) {
                if (depreciationsDecreaseAmounts[key3] !== 0) {
                    const innerValue3 = depreciationsDecreaseAmounts[key3];
                    bundleSheet.fields[key3].forceUserValue(innerValue3);
                }
            }
        }

        if (this.bundleSheets["2033C"]) {
            const bundleSheet = this.bundleSheets["2033C"];

            for (const key in fixedAssetsPreviousAmounts) {
                if (fixedAssetsPreviousAmounts[key] !== 0) {
                    const innerValue = fixedAssetsPreviousAmounts[key];
                    bundleSheet.fields[key].forceUserValue(innerValue);
                }
            }

            for (const key2 in fixedAssetsIncreaseAmounts) {
                if (fixedAssetsIncreaseAmounts[key2] !== 0) {
                    const innerValue2 = fixedAssetsIncreaseAmounts[key2];
                    bundleSheet.fields[key2].forceUserValue(innerValue2);
                }
            }

            for (const key3 in fixedAssetsDecreaseAmounts) {
                if (fixedAssetsDecreaseAmounts[key3] !== 0) {
                    const innerValue3 = fixedAssetsDecreaseAmounts[key3];
                    bundleSheet.fields[key3].forceUserValue(innerValue3);
                }
            }

            for (const key in depreciationsPreviousAmounts) {
                if (depreciationsPreviousAmounts[key] !== 0) {
                    const innerValue = depreciationsPreviousAmounts[key];
                    bundleSheet.fields[key].forceUserValue(innerValue);
                }
            }

            for (const key2 in depreciationsIncreaseAmounts) {
                if (depreciationsIncreaseAmounts[key2] !== 0) {
                    const innerValue2 = depreciationsIncreaseAmounts[key2];
                    bundleSheet.fields[key2].forceUserValue(innerValue2);
                }
            }

            for (const key3 in depreciationsDecreaseAmounts) {
                if (depreciationsDecreaseAmounts[key3] !== 0) {
                    const innerValue3 = depreciationsDecreaseAmounts[key3];
                    bundleSheet.fields[key3].forceUserValue(innerValue3);
                }
            }
        }
    }

    async setSCIBuildings() {
        if (this.bundleType === "SCI") {
            const buildings = await this.getBuildings();
            if (buildings?.properties?.length) {
                const buildingImport = this.SCICorrespondenceTable.import.find(
                    (sciIimport) => sciIimport.name === "building"
                );
                if (buildingImport) {
                    //
                    // formulaire building = 2072S2
                    //
                    let prevCodification;
                    let pageBuildingIndex = 0;
                    let buildingNum = 1;
                    // let cellRepeatIndex = 0

                    // let pageExtension
                    let bundleSheet;
                    for (const building of buildings.properties) {
                        const codification = buildingImport.importCodification.find(
                            (form) =>
                                form.page?.startsWith("2072S2") &&
                                form.lineStart <= buildingNum &&
                                form.lineEnd >= buildingNum
                        );
                        if (codification) {
                            // let page
                            if (prevCodification && prevCodification?.page !== codification.page) {
                                pageBuildingIndex = 0;
                                // pageExtension = 1
                                bundleSheet = await this.createAdditionalPage(codification.page);
                                // cellRepeatIndex = 0
                            } else if (
                                codification.repeat &&
                                pageBuildingIndex >= codification.repeatMaxCount
                            ) {
                                pageBuildingIndex = 0;
                                // pageExtension++
                                bundleSheet = await this.createAdditionalPage(codification.page);
                                // cellRepeatIndex = 0
                            } else if (!bundleSheet) {
                                pageBuildingIndex = 0;
                                bundleSheet = this.bundleSheets[codification.page];
                            }
                            // if (pageExtension) {

                            // }
                            // (!form.repeat || form.repeatMaxCount >= buildingNum)
                            // let bundleSheet = this.bundleSheets[page]
                            // if (!bundleSheet) {
                            //     bundleSheet = await this.createAdditionalPage(codification.page)
                            //     cellRepeatIndex = 0
                            // }
                            if (bundleSheet) {
                                for (const element of codification.data) {
                                    if (element.name === "address") {
                                        const [streetNumber, btq, street] =
                                            this.extractNumberAndBtq(building.address);
                                        const address = {
                                            "@A": streetNumber,
                                            "@B": btq,
                                            "@C": street,
                                            "@E": building.postalCode,
                                            "@F": building.city,
                                            "@G": building.country,
                                        };
                                        for (const key in address) {
                                            const field =
                                                bundleSheet.fields[
                                                    `${element.cell[pageBuildingIndex]}_${key}`
                                                ];
                                            if (field && address[key]) {
                                                field.value = address[key];
                                            }
                                        }
                                    } else {
                                        const field =
                                            bundleSheet.fields[element.cell[pageBuildingIndex]];
                                        if (field) {
                                            if (element.name === "number") {
                                                field.value = buildingNum;
                                            } else if (
                                                element.name === "natureA" ||
                                                element.name === "natureB" ||
                                                element.name === "specificDeduction" ||
                                                element.name === "depreciationDeduction"
                                            ) {
                                                const selector =
                                                    this.selectors[
                                                        bundleSheet._form.values[field.key].selector
                                                    ];
                                                if (building[element.name] === "Bati") {
                                                    building[element.name] = "Bâti";
                                                }
                                                if (building[element.name] === "Non bati") {
                                                    building[element.name] = "Non bâti";
                                                }
                                                const value = selector.values.find(
                                                    (value) => value.text === building[element.name]
                                                );
                                                if (!value) {
                                                    console.error(
                                                        `no correspondence in selector ${
                                                            selector.table
                                                        } for value "${building[element.name]}"`
                                                    );
                                                    continue;
                                                }
                                                field.value = value.value;
                                            } else if (
                                                element.name === "isAcquiredDateInFiscalYear"
                                            ) {
                                                if (
                                                    moment(building.acquiredDate).isSameOrAfter(
                                                        this.accountingPeriod.start
                                                    ) &&
                                                    moment(building.acquiredDate).isSameOrBefore(
                                                        this.accountingPeriod.end
                                                    )
                                                ) {
                                                    field.value = "1";
                                                }
                                            } else if (building[element.name]) {
                                                field.value = building[element.name];
                                            }
                                        } else {
                                            console.error(
                                                `Field ${element.cell[pageBuildingIndex]} not found in bundle sheet ${bundleSheet.cerfaNumber}`
                                            );
                                        }
                                    }
                                }
                            } else {
                                console.error(
                                    "setSCIBuildings(2072S2) => bundleSheet not found for ",
                                    codification.page
                                );
                            }
                        }
                        prevCodification = codification;
                        buildingNum++;
                        pageBuildingIndex++;
                    }
                    //
                    // formulaire 2 : 2072SA11
                    //
                    if (this.buildingBalances) {
                        prevCodification = undefined;
                        pageBuildingIndex = 0;
                        buildingNum = 1;
                        bundleSheet = undefined;
                        for (const building of buildings.properties) {
                            const codification = buildingImport.importCodification.find(
                                (form) =>
                                    form.page?.startsWith("2072SA1") &&
                                    form.lineStart <= buildingNum &&
                                    form.lineEnd >= buildingNum
                            );
                            if (codification) {
                                if (
                                    prevCodification &&
                                    prevCodification?.page !== codification.page
                                ) {
                                    pageBuildingIndex = 0;
                                    bundleSheet = await this.createAdditionalPage(
                                        codification.page
                                    );
                                } else if (
                                    codification.repeat &&
                                    pageBuildingIndex >= codification.repeatMaxCount
                                ) {
                                    pageBuildingIndex = 0;
                                    bundleSheet = await this.createAdditionalPage(
                                        codification.page
                                    );
                                } else if (!bundleSheet) {
                                    pageBuildingIndex = 0;
                                    bundleSheet = this.bundleSheets[codification.page];
                                }
                                if (bundleSheet) {
                                    let radicals;
                                    if (this.buildingBalances) {
                                        const balances = this.buildingBalances[building.name];
                                        if (balances) {
                                            const plr = this.getPLR(codification.radicalsPlan);
                                            radicals = this._generateRadicals(balances, plr);
                                        } else {
                                            console.error("2072SA1 balances not found");
                                        }
                                    }
                                    if (!radicals) {
                                        console.error("2072SA1 radicals not found");
                                    }
                                    for (const element of codification.data) {
                                        const field =
                                            bundleSheet.fields[element.cell[pageBuildingIndex]];
                                        if (field) {
                                            if (element.name === "number") {
                                                field.value = buildingNum;
                                            } else {
                                                // @ts-ignore
                                                if (radicals && element.function) {
                                                    var matchResult =
                                                        // @ts-ignore
                                                        element.function.match(
                                                            /^\[RAD([0-9]{1,})\]$/
                                                        );
                                                    if (matchResult?.length === 2) {
                                                        const radical = matchResult[1];
                                                        const value: number =
                                                            radicals[radical] || 0;
                                                        if (value) {
                                                            field.forceUserValue(value);
                                                        }
                                                    } else {
                                                        console.error(
                                                            "2072SA1 function not managed= ",
                                                            element.name
                                                        );
                                                    }
                                                } else {
                                                    console.error(
                                                        "2072SA1 not filled field= ",
                                                        element.name
                                                    );
                                                }
                                            }
                                        } else {
                                            console.error(
                                                `Field ${element.cell[pageBuildingIndex]} not found in bundle sheet ${bundleSheet.cerfaNumber}`
                                            );
                                        }
                                    }
                                } else {
                                    console.error(
                                        "setSCIBuildings(2072SA1) bundleSheet not found for ",
                                        codification.page
                                    );
                                }
                            } else {
                                console.error(
                                    "codification not found for 2072SA11 and buildingNum=",
                                    buildingNum
                                );
                            }
                            prevCodification = codification;
                            buildingNum++;
                            pageBuildingIndex++;
                        }
                    }
                } else {
                }
            }
        }
    }

    async setHeadOffice() {
        if (this.bundleSheets) {
            const fields = this.bundleSheets["2065"]?.fields || null;
            if (fields && this.companyDetails) {
                const details: CompanyDetails = this.companyDetails;
                const [streetNumber, btq, street] = this.extractNumberAndBtq(details.address);
                const address = {
                    "@A": streetNumber,
                    "@B": btq,
                    "@C": street,
                    "@D": details.addressComplement,
                    "@E": details.postalCode,
                    "@F": details.city,
                    "@G": details.country,
                    "@H": details.legalForm,
                    "@I": details.name,
                    "@J": null,
                    "@K": null,
                };
                const prefix = "AC_";
                for (const key in address) {
                    const field = fields[prefix + key];
                    if (field && address[key]) {
                        field.value = address[key];
                    }
                }
            }
        }
    }

    async setAccountant() {
        if (this.bundleSheets) {
            const fields =
                this.bundleSheets["2065"]?.fields ||
                this.bundleSheets["2072S1"]?.fields ||
                this.bundleSheets["OGBNC00"]?.fields ||
                null;
            if (fields) {
                const accountingFirms = await this.getAccountingFirmsOfCompanyQuery();
                let accountingFirm = { address: "", postalCode: "", city: "" };
                if (accountingFirms.length) {
                    accountingFirm = accountingFirms[0].accountingFirm;
                }
                const fixedVariables = this.fixedVariables;
                const [streetNumber, btq, street] = this.extractNumberAndBtq(
                    accountingFirm.address
                );
                const address = {
                    "@A": streetNumber,
                    "@B": btq,
                    "@C": street,
                    "@E": accountingFirm.postalCode,
                    "@F": accountingFirm.city,
                    "@I": fixedVariables?.Y1,
                    "@K": fixedVariables?.Y2,
                };
                const prefix = this.bundleSheets["2065"]
                    ? "CA_"
                    : this.bundleSheets["2072S1"]
                    ? "ZB_"
                    : "AA_";
                for (const key in address) {
                    const field = fields[prefix + key];
                    if (field && address[key]) {
                        field.value = address[key];
                    }
                }
            }
        }
    }

    async setPreviousDeficitsCarriedForward(latestN1ValidBundle) {
        let N1BundleSheetData = null;
        if (latestN1ValidBundle) {
            const N1BundleSheet = latestN1ValidBundle.bundleSheets.filter(
                (sheet) => sheet.form.cerfaNumber === "2033D" || sheet.form.cerfaNumber === "2058B"
            );
            N1BundleSheetData = N1BundleSheet[0]?.data;
        }
        if (N1BundleSheetData && this.bundleSheets) {
            const fieldN =
                this.bundleSheets["2033B"]?.fields["JA"] ||
                this.bundleSheets["2058B"]?.fields["DQ"] ||
                null;
            const fieldN1 = N1BundleSheetData["MH"] || N1BundleSheetData["YK"] || null;
            if (fieldN && fieldN1) {
                fieldN.forceUserValue(fieldN1.userValue || fieldN1.computedValue);
            }
        }
    }

    async setSubsidiaries(latestN1ValidBundle) {
        // retrieving fields
        let N1BundleSheetFields = null;
        let NBundleSheetFields = null;
        if (latestN1ValidBundle) {
            const N1BundleSheet = latestN1ValidBundle.bundleSheets.filter(
                (sheet) => sheet.form.cerfaNumber === "2033G" || sheet.form.cerfaNumber === "2059G"
            );
            if (N1BundleSheet && N1BundleSheet.length) {
                const N1Data = Object.entries(N1BundleSheet[0].data);
                const N1FData = N1Data.filter(([key, value]) => /^[G-O]/.test(key));
                if (N1FData) {
                    N1BundleSheetFields = Object.fromEntries(N1FData);
                }
            }
        }
        if (this.bundleSheets) {
            const NBundleSheet = this.bundleSheets["2033G"] || this.bundleSheets["2059G"];
            if (NBundleSheet) {
                const NData = Object.entries(NBundleSheet.fields);
                const NFData = NData.filter(([key, value]) => /^[G-O]/.test(key));
                if (NFData) {
                    NBundleSheetFields = Object.fromEntries(NFData);
                }
            }
        }
        if (N1BundleSheetFields && NBundleSheetFields) {
            // checking if the fields are already filled
            function checkValues(obj) {
                for (const key in obj) {
                    if (obj[key].value !== null) {
                        return true;
                    }
                }
                return false;
            }
            if (checkValues(NBundleSheetFields)) {
                return;
            }
            // copying fields from N1 to N
            for (const key in N1BundleSheetFields) {
                if (key in NBundleSheetFields) {
                    NBundleSheetFields[key].value = N1BundleSheetFields[key].userValue;
                }
            }
        }
    }

    async setOGA() {
        const { ogaEnrolmentConfig } = this.settingsVariables;
        if (this.bundleSheets && ogaEnrolmentConfig) {
            const fields = this.bundleSheets["2035A"]?.fields || null;
            if (fields) {
                fields["GH"].value = "1";
                fields["FF"].value = ogaEnrolmentConfig.year;
            }
        }
    }

    async getSettingsVariables() {
        const profileCompany = await this.getSettingsVariablesQuery();
        if (profileCompany) {
            this.settingsVariables = {
                taxSystem: {
                    income: profileCompany.company.incomeCategory,
                    regime: profileCompany.company.taxRegime,
                    type: profileCompany.company.taxSystemType,
                },
            };
            if (profileCompany?.ogaEnrolment) {
                this.settingsVariables.ogaEnrolmentConfig = {
                    address: profileCompany.ogaEnrolmentConfig?.address,
                    postalCode: profileCompany.ogaEnrolmentConfig?.postalCode,
                    city: profileCompany.ogaEnrolmentConfig?.city,
                    designation: profileCompany.ogaEnrolmentConfig?.designation,
                    numberId: profileCompany.ogaEnrolmentConfig?.numberId,
                    siret: profileCompany.ogaEnrolmentConfig?.siret,
                    year: profileCompany.ogaEnrolmentConfig?.year,
                };

                this.settingsVariables.ogaEnrolment = profileCompany.ogaEnrolment || {
                    address: "",
                    postalCode: "",
                    city: "",
                    designation: "",
                    numberId: "",
                    siret: "",
                    year: "",
                };
            }
            if (this.bundleN1) {
                this.bundleN1.settingsVariables = this.settingsVariables;
            }
        }
    }

    async setLegalForm() {
        if (this.companyId) {
            if (this.bundleSheets) {
                const fields = this.bundleSheets["OGID00"]?.fields || null;
                if (fields) {
                    const field = fields["AB"];
                    if (field && this.companyDetails?.legalForm) {
                        field.value = this.companyDetails.legalForm;
                    }
                }
            }
        }
    }

    async setCompanyActivities() {
        if (this.companyId) {
            if (this.bundleSheets["2035"]) {
                const fields = this.bundleSheets["2035"].fields;
                if (fields) {
                    const field = fields["EA"];
                    if (field && this.companyDetails?.activities?.length) {
                        field.value = this.companyDetails.activities[0].description;
                    }
                }
            }
            if (this.bundleSheets["2031"]) {
                const fields = this.bundleSheets["2031"].fields;
                if (fields) {
                    const field = fields["AB"];
                    if (field && this.companyDetails?.activities?.length) {
                        field.value = this.companyDetails.activities[0].description;
                    }
                }
            }
            if (this.bundleSheets["2035A"]) {
                const fields = this.bundleSheets["2035A"].fields;
                if (fields) {
                    const field = fields["FA"];
                    if (field && this.companyDetails?.activities?.length) {
                        field.forceUserValue(this.companyDetails.activities[0].description);
                    }
                }
            }
            if (this.bundleSheets["2065"]) {
                const fields = this.bundleSheets["2065"].fields;
                if (fields) {
                    const field = fields["AQ"];
                    if (field && this.companyDetails?.activities?.length) {
                        field.value = this.companyDetails.activities[0].description;
                    }
                }
            }
        }
    }

    async setOGAEnrolment() {
        if (this.bundleSheets) {
            const fields = this.bundleSheets["OGBNC00"]?.fields || null;
            if (fields) {
                if (this.settingsVariables.ogaEnrolmentConfig) {
                    const [streetNumber, btq, street] = this.extractNumberAndBtq(
                        this.settingsVariables.ogaEnrolmentConfig.address
                    );
                    const prefix = "AC_";
                    const address = {
                        "@L": this.settingsVariables.ogaEnrolmentConfig.numberId,
                        "@I": this.settingsVariables.ogaEnrolmentConfig.designation,
                        "@A": streetNumber,
                        "@B": btq,
                        "@C": street,
                        "@E": this.settingsVariables.ogaEnrolmentConfig.postalCode,
                        "@F": this.settingsVariables.ogaEnrolmentConfig.city,
                    };

                    for (const key in address) {
                        const field = fields[prefix + key];
                        if (field && address[key]) {
                            field.value = address[key];
                        }
                    }
                }
            }
        }
    }

    async setProfession() {
        if (this.bundleSheets) {
            const fields =
                this.bundleSheets["OGBNC00"]?.fields || this.bundleSheets["OGBIC00"] || null;
            if (fields) {
                const field = fields["AB"];
                if (field && this.companyDetails?.activities?.length) {
                    field.value = this.companyDetails.activities[0].description || "";
                }
            }
        }
    }

    async setAccountingPeriodCVAE() {
        if (this.bundleSheets) {
            const fields =
                this.bundleSheets["2035E"]?.fields || this.bundleSheets["2059E"]?.fields || null;
            if (fields) {
                const fieldKB = fields["KB"];
                const fieldKC = fields["KC"];

                if (fieldKB) {
                    fieldKB.value = moment(this.accountingPeriod.start).format("DD/MM/YYYY");
                }
                if (fieldKC) {
                    fieldKC.value = moment(this.accountingPeriod.end).format("DD/MM/YYYY");
                }
            }
        }
    }

    async setBusinessStartDate() {
        if (this.bundleSheets) {
            const fields = this.bundleSheets["2035"]?.fields || null;
            if (fields) {
                const field = fields["EB"];
                if (field && this.companyDetails?.startBusinessDate) {
                    field.value = moment(this.companyDetails.startBusinessDate).format(
                        "DD/MM/YYYY"
                    );
                }
            }
        }
    }

    async setSubjectToTVA() {
        if (this.bundleSheets) {
            const fields = this.bundleSheets["2035A"]?.fields || null;
            if (fields) {
                const field = fields["GK"];
                if (field && this.companyDetails?.vatSystem) {
                    if (isNotSubjectToVAT(this.companyDetails?.vatSystem)) {
                        field.value = "1";
                    }
                }
            }
        }
    }

    async setOGBNCVat() {
        if (this.bundleSheets) {
            const fields2035B = this.bundleSheets["2035B"]?.fields || null;
            const fieldsOGBNC04 = this.bundleSheets["OGBNC04"]?.fields || null;

            if (fields2035B && fieldsOGBNC04) {
                const fieldCX = fields2035B["CX"];
                const fieldAW = fieldsOGBNC04["AW"];

                const fieldCY = fields2035B["CY"];
                const fieldAY = fieldsOGBNC04["AY"];

                if (fieldCX) {
                    fieldAW.value = fieldCX.value;
                }

                if (fieldCY) {
                    fieldAY.value = fieldCY.value;
                }
            }
        }
    }

    async setOGBNCDefaultValue(companyId) {
        if (this.bundleSheets) {
            const fields = this.bundleSheets["OGBNC04"]?.fields || null;
            if (fields) {
                if (fields["AZ_02"] && !fields["AZ_02"].value) {
                    fields["AZ_02"].value = 0;
                }
                if (fields["AZ_03"] && !fields["AZ_03"].value) {
                    fields["AZ_03"].value = 0;
                }
                if (fields["AZ_04"] && !fields["AZ_04"].value) {
                    fields["AZ_04"].value = 0;
                }
                if (fields["AZ_05"] && !fields["AZ_05"].value) {
                    fields["AZ_05"].value = 0;
                }
                if (fields["AZ_06"] && !fields["AZ_06"].value) {
                    fields["AZ_06"].value = 0;
                }
                if (fields["AZ_07"] && !fields["AZ_07"].value) {
                    fields["AZ_07"].value = 0;
                }
                if (fields["BC_02"] && !fields["BC_02"].value) {
                    fields["BC_02"].value = 0;
                }
                if (fields["BC_03"] && !fields["BC_03"].value) {
                    fields["BC_03"].value = 0;
                }
                if (fields["BC_04"] && !fields["BC_04"].value) {
                    fields["BC_04"].value = 0;
                }
                if (fields["BC_05"] && !fields["BC_05"].value) {
                    fields["BC_05"].value = 0;
                }
                if (fields["BC_06"] && !fields["BC_06"].value) {
                    fields["BC_06"].value = 0;
                }
                if (fields["BC_07"] && !fields["BC_07"].value) {
                    fields["BC_07"].value = 0;
                }
            }
        }
    }

    async setSignature(companyId) {
        if (this.bundleSheets) {
            if (this.fixedVariables) {
                let prefix = "";
                // let fields = null
                const signature = {
                    "@I": this.fixedVariables?.Y1,
                    "@K": this.fixedVariables?.Y2,
                    "@F": this.fixedVariables?.signatureCity,
                };
                if (this.bundleSheets["2035"]) {
                    prefix = "LB_";
                    const fields = this.bundleSheets["2035"]?.fields;

                    if (fields) {
                        for (const key in signature) {
                            const field = fields[prefix + key];
                            if (field && signature[key]) {
                                field.value = signature[key];
                            }
                        }
                    }
                }
                if (this.bundleSheets["OGBIC00"] || this.bundleSheets["OGBNC00"]) {
                    prefix = "AD_";
                    const fields =
                        this.bundleSheets["OGBIC00"]?.fields ||
                        this.bundleSheets["OGBNC00"]?.fields;

                    if (fields) {
                        for (const key in signature) {
                            const field = fields[prefix + key];
                            if (field && signature[key]) {
                                field.value = signature[key];
                            }
                        }
                    }
                }
                if (this.bundleSheets["2065"]) {
                    prefix = "GF_";
                    const fields = this.bundleSheets["2065"]?.fields;
                    if (fields) {
                        for (const key in signature) {
                            const field = fields[prefix + key];
                            if (field && signature[key]) {
                                field.value = signature[key];
                            }
                        }
                    }
                }
                if (this.bundleSheets["2031"]) {
                    prefix = "HB_";
                    const fields = this.bundleSheets["2031"]?.fields;

                    if (fields) {
                        for (const key in signature) {
                            const field = fields[prefix + key];
                            if (field && signature[key]) {
                                field.value = signature[key];
                            }
                        }
                    }
                }
            }
        }
    }

    async setSCIShares(SCIassociates, accountingStart, accountingEnd) {
        function calculateShares(associates, startDate, endDate) {
            const result = {
                associatesCount: 0,
                sharesAtStart: 0,
                sharesIncrease: 0,
                sharesDecrease: 0,
                sharesAtEnd: 0,
                nominalAtStart: 0,
                nominalAtEnd: 0,
            };
            for (const associate of associates) {
                const shares = associate.shares;
                const filteredShares = shares.filter((share) => share.date <= endDate); // eliminate shares with date above accounting period end
                if (filteredShares.length) {
                    // associatesCount
                    result.associatesCount += 1;
                    // sharesAtEnd
                    const sortedShares = filteredShares.sort(sortSharesByDate);
                    result.sharesAtEnd += sortedShares[0].quantity || 0;
                    // sharesAtStart
                    const newFilteredShares = sortedShares.filter(
                        (share) => share.date < startDate
                    );
                    newFilteredShares.length &&
                        (result.sharesAtStart += newFilteredShares[0].quantity);
                }
            }

            // sharesIncrease and sharesDecrease
            const diff = result.sharesAtEnd - result.sharesAtStart;
            diff >= 0 ? (result.sharesIncrease = diff) : (result.sharesDecrease = -diff);

            let allShares = [];
            for (const associate of associates) {
                const shares = associate.shares;
                const filteredShares = shares.filter((share) => share.date <= endDate); // eliminate shares with dates above accounting period end
                filteredShares.length && allShares.push(...filteredShares);
            }

            if (allShares.length) {
                const sortedShares = allShares.sort(sortSharesByDate);
                // nominalAtEnd
                result.nominalAtEnd = sortedShares[0].amount;
                // nominalAtStart
                result.nominalAtStart = result.nominalAtEnd;
                for (const share of sortedShares) {
                    result.nominalAtStart = share.amount;
                    if (share.date < startDate) {
                        return result;
                    }
                }
            }
            return result;
        }

        const accountingPeriodStart = moment(accountingStart).format("YYYY-MM-DD");
        const accountingPeriodEnd = moment(accountingEnd).format("YYYY-MM-DD");
        if (this.bundleSheets) {
            const fields = this.bundleSheets["2072S1"]?.fields || null;
            if (fields) {
                const shares = calculateShares(
                    SCIassociates,
                    accountingPeriodStart,
                    accountingPeriodEnd
                );
                fields["BE"].value = shares.associatesCount;
                fields["BF"].value = shares.sharesAtStart;
                fields["BN"].value = shares.nominalAtStart;
                fields["DJ"].value = shares.sharesIncrease;
                fields["EA"].value = shares.sharesDecrease;
                fields["AQ"].value = shares.sharesAtEnd;
                fields["AR"].value = shares.nominalAtEnd;
            }
        }
    }

    async setCompanyAssociatesSCI() {
        if (this.bundleType !== "SCI") {
            return;
        }
        if (this.associates.length) {
            const groupedAssociates: {
                [key: string]: any[];
            } = groupBy(this.associates, "partnerType");

            if (groupedAssociates["professionalRegimeAssociate"]) {
                await this.setCompanyProfessionalRegimeAssociate(
                    groupedAssociates["professionalRegimeAssociate"]
                );
            }
            if (groupedAssociates["null"]) {
                await this.setCompanyProfessionalRegimeAssociate(groupedAssociates["null"]);
            }
            if (groupedAssociates["landTenureAssociate"]) {
                await this.setCompanyLandTenureAssociate(
                    groupedAssociates["landTenureAssociate"],
                    this.accountingPeriod.end
                );
            }
            this.setSCIShares(
                this.associates,
                this.accountingPeriod.start,
                this.accountingPeriod.end
            );
        }
    }

    calculateAssociatesSums(associates, legalForm, accountingEnd) {
        const result = {
            legal: { persons: 0, shares: 0 },
            natural: { persons: 0, shares: 0 },
        };
        for (const associate of associates) {
            result[associate.type === "LEGAL_PERSON" ? "legal" : "natural"].persons += 1;
            if (legalForm === "SCI") {
                const filteredShares = associate.shares.filter(
                    (share) => share.date <= accountingEnd
                );
                if (filteredShares.length) {
                    const sortedShares = filteredShares.sort(sortSharesByDate);
                    result[associate.type === "LEGAL_PERSON" ? "legal" : "natural"].shares +=
                        sortedShares[0].quantity || 0;
                }
            } else {
                result[associate.type === "LEGAL_PERSON" ? "legal" : "natural"].shares +=
                    associate.capitalAmount || 0;
            }
        }
        return result;
    }

    async setCompanyAssociates() {
        if (!["BICRNS", "BICRNP", "BICRSS", "BICRSP", "BARSA"].includes(this.bundleType)) {
            return;
        }
        if (!this.associates.length) {
            return;
        }

        const accountingEnd = this.accountingPeriod.end;

        //
        // régime normal 2059F + 2065B
        //
        // 2059F
        const BICRNP_BICRNS_cerfaToFill = {
            ALL: undefined,
            LEGAL_PERSON: {
                // personne morale
                capitalAmountField: "GD",
                percentageField: "GR",
                index: 0,
                first: {
                    name: "2059F",
                    fields: ["GA", "HA", "IA", "JA"],
                },
                extension: {
                    name: "2059F1",
                    fields: ["HA", "IA", "JA", "KA", "LA", "MA", "NA", "OA", "PA", "QA"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2059F",
                fieldToCheck: "GD",
            },
            NATURAL_PERSON: {
                // personne physique
                capitalAmountField: "BD",
                percentageField: "BR",
                birdthDateField: "BE",
                index: 0,
                first: {
                    name: "2059F",
                    fields: ["BA", "CA", "DA"],
                    births: ["BG", "CF", "DF"],
                },
                extension: {
                    name: "2059F2",
                    fields: ["BA", "CA", "DA", "EA", "FA", "GA", "HA"],
                    births: ["BG", "CF", "DF", "EF", "FF", "GF", "HF"],
                },
                currentBundleSheetName: "2059F",
                fieldToCheck: "BD",
            },
        };
        // 2065B
        // société (IS)
        const BICRNS_BICRSS_cerfaToFill = {
            ALL: {
                capitalAmountField: "CG",
                percentageField: undefined,
                index: 0,
                first: {
                    name: "2065B",
                    fields: ["CA", "XA", "XB", "XC"],
                },
                extension: {
                    name: "2065BEX1",
                    fields: ["XA", "XB", "XC", "XD", "XE", "XF", "XG"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2065B",
                fieldToCheck: "CG",
            },
            LEGAL_PERSON: undefined,
            NATURAL_PERSON: undefined,
        };

        //
        // RS : régime simplifié 2033F + 2031BIS
        //
        // 2033F
        const BICRSP_BICRSS_cerfaToFill = {
            ALL: undefined,
            LEGAL_PERSON: {
                // personne morale
                capitalAmountField: "GD",
                percentageField: "GR",
                index: 0,
                first: {
                    name: "2033F",
                    fields: ["GA", "HA", "IA", "JA"],
                },
                extension: {
                    name: "2033F1",
                    fields: ["HA", "IA", "JA", "KA", "LA", "MA", "NA", "OA", "PA", "QA"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2033F",
                fieldToCheck: "GD",
            },
            NATURAL_PERSON: {
                // personne physique
                capitalAmountField: "BD",
                percentageField: "BR",
                birdthDateField: "BE",
                // birdthDateAdressField: "BG",
                index: 0,
                first: {
                    name: "2033F",
                    fields: ["BA", "CA", "DA"],
                    births: ["BG", "CF", "DF"],
                },
                extension: {
                    name: "2033F2",
                    fields: ["BA", "CA", "DA", "EA", "FA", "GA", "HA"],
                    births: ["BG", "CF", "DF", "EF", "FF", "GF", "HF"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2033F",
                fieldToCheck: "BD",
            },
        };
        // 2031BIS
        // personne (IR)
        const BICRNP_BICRSP_cerfaToFill = {
            ALL: undefined,
            LEGAL_PERSON: {
                // personne morale
                index: 0,
                first: {
                    name: "2031BIS",
                    fields: ["AA", "AZ"],
                },
                extension: {
                    name: "2031BEX1",
                    fields: ["AB", "AC", "AD", "AE", "AF", "AG"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2031BIS",
                fieldToCheck: "AH",
            },
            NATURAL_PERSON: {
                // personne physique
                birdthDateField: "AU",
                index: 0,
                first: {
                    name: "2031BIS",
                    fields: ["AW", "ZW"],
                    births: ["AV", "ZV"],
                },
                extension: {
                    name: "2031BEX4",
                    fields: ["ZA", "ZB", "ZC", "ZD", "ZE", "ZF"],
                    births: ["WA", "WB", "WC", "WD", "WE", "WF"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2031BIS",
                fieldToCheck: "AU",
            },
        };

        //
        // BA simplifié 2139C
        //
        const BARSA_cerfaToFill = {
            ALL: undefined,
            LEGAL_PERSON: {
                // personne morale
                capitalAmountField: "GD",
                percentageField: "GR",
                index: 0,
                first: {
                    name: "2139C",
                    fields: ["GA", "HA", "IA", "JA"],
                },
                extension: {
                    name: "2139CB",
                    fields: ["HA", "IA", "JA", "KA", "LA", "MA", "NA", "OA", "PA", "QA"],
                },
                currentCerfa: null,
                currentBundleSheetName: "2139C",
                fieldToCheck: "GD",
            },
            NATURAL_PERSON: {
                // personne physique
                capitalAmountField: "BD",
                percentageField: "BR",
                birdthDateField: "BE",
                index: 0,
                first: {
                    name: "2139C",
                    fields: ["BA", "CA", "DA"],
                    births: ["BG", "CF", "DF"],
                },
                extension: {
                    name: "2139CT",
                    fields: ["BA", "CA", "DA", "EA", "FA", "GA", "HA"],
                    births: ["BG", "CF", "DF", "EF", "FF", "GF", "HF"],
                },
                currentBundleSheetName: "2139C",
                fieldToCheck: "BD",
            },
        };

        const cerfas =
            this.bundleType === "BICRNS"
                ? [BICRNP_BICRNS_cerfaToFill, BICRNS_BICRSS_cerfaToFill]
                : this.bundleType === "BICRNP"
                ? [BICRNP_BICRNS_cerfaToFill, BICRNP_BICRSP_cerfaToFill]
                : this.bundleType === "BICRSS"
                ? [BICRSP_BICRSS_cerfaToFill, BICRNS_BICRSS_cerfaToFill]
                : this.bundleType === "BICRSP"
                ? [BICRSP_BICRSS_cerfaToFill, BICRNP_BICRSP_cerfaToFill]
                : this.bundleType === "BARSA"
                ? [BARSA_cerfaToFill]
                : [];

        const accountingPeriodEnd = moment(accountingEnd).format("YYYY-MM-DD");

        // global associates and shares
        if (this.associates && this.bundleSheets) {
            const sums = this.calculateAssociatesSums(
                this.associates,
                this.legalForm,
                accountingPeriodEnd
            );
            const cerfaToFill: string = cerfas[0].LEGAL_PERSON.currentBundleSheetName;
            const bundleSheet = this.bundleSheets[cerfaToFill];
            if (bundleSheet) {
                bundleSheet.fields["GT"].value = sums.legal.persons || null;
                bundleSheet.fields["GV"].value = sums.natural.persons || null;
                bundleSheet.fields["GU"].value = sums.legal.shares || null;
                bundleSheet.fields["GW"].value = sums.natural.shares || null;
            } else {
                debugger;
            }
        }

        // cerfas one by one
        for (const cerfaToFill of cerfas) {
            // current cerfa
            if (cerfaToFill.ALL) {
                cerfaToFill.ALL.currentCerfa = cerfaToFill.ALL.first;
            }
            if (cerfaToFill.LEGAL_PERSON) {
                cerfaToFill.LEGAL_PERSON.currentCerfa = cerfaToFill.LEGAL_PERSON.first;
            }
            if (cerfaToFill.NATURAL_PERSON) {
                cerfaToFill.NATURAL_PERSON.currentCerfa = cerfaToFill.NATURAL_PERSON.first;
            }

            // associates one by one
            for (const associate of this.associates) {
                // cerfa
                let cerfa;
                if (cerfaToFill.ALL) {
                    cerfa = cerfaToFill.ALL;
                } else {
                    if (cerfaToFill.LEGAL_PERSON && associate.type === "LEGAL_PERSON") {
                        cerfa = cerfaToFill.LEGAL_PERSON;
                    } else if (cerfaToFill.NATURAL_PERSON && associate.type === "NATURAL_PERSON") {
                        cerfa = cerfaToFill.NATURAL_PERSON;
                    } else {
                    }
                }

                // key extension
                let keyExtension = "";
                if (cerfa.index < 1) {
                    keyExtension = "";
                } else {
                    const suffix = `${cerfa.index + 1}`;
                    keyExtension = `_${suffix.padStart(2, "0")}`;
                }

                // create additional page
                if (
                    !this.bundleSheets?.[cerfa.currentBundleSheetName]?.fields?.[
                        `${cerfa.fieldToCheck}${keyExtension}`
                    ]
                ) {
                    if (cerfa.extension) {
                        const page = await this.createAdditionalPage(cerfa.extension.name);
                        cerfa.currentBundleSheetName = page.name;
                        cerfa.index = 0;
                        keyExtension = "";
                        cerfa.currentCerfa = cerfa.extension;
                    } else {
                        console.error("pas d'extension pour le cerfa= ", cerfaToFill);
                        break;
                    }
                }

                const bundleSheet = this.bundleSheets[cerfa.currentBundleSheetName];
                if (bundleSheet?.fields[`${cerfa.fieldToCheck}${keyExtension}`]) {
                    // address
                    const [streetNumber, btq, street] = this.extractNumberAndBtq(associate.address);
                    let legalFormOrCivility = "";
                    if (associate.legalForm) {
                        legalFormOrCivility = associate.legalForm;
                    } else if (associate.civility === "MR") {
                        legalFormOrCivility = "Monsieur";
                    } else if (associate.civility === "MS") {
                        legalFormOrCivility = "Madame";
                    }
                    const address = {
                        "@A": streetNumber,
                        "@B": btq,
                        "@C": street,
                        "@D": associate.addressComplement,
                        "@E": associate.postalCode,
                        "@F": associate.city,
                        "@G": associate.country,
                        "@H": legalFormOrCivility,
                        "@I": associate.lastname,
                        "@J": associate.firstname,
                        "@K": associate.marriedName,
                    };
                    for (const key in address) {
                        const field =
                            bundleSheet.fields[`${cerfa.currentCerfa.fields[cerfa.index]}_${key}`];
                        if (field && address[key]) {
                            field.value = address[key];
                        }
                    }
                    // shares, quantity and percentage
                    let capital = 0;
                    let percentage = 0;
                    if (this.legalForm === "SCI") {
                        const filteredShares = associate.shares.filter(
                            (share) => share.date <= accountingPeriodEnd
                        );
                        if (filteredShares.length) {
                            const sortedShares = filteredShares.sort(sortSharesByDate);
                            capital = sortedShares[0].quantity || 0;
                            percentage = sortedShares[0].percentage || 0;
                        }
                    } else {
                        capital = associate.capitalAmount;
                        percentage = associate.capitalPercentage;
                    }
                    if (bundleSheet.fields[`${cerfa.capitalAmountField}${keyExtension}`]) {
                        bundleSheet.fields[`${cerfa.capitalAmountField}${keyExtension}`].value =
                            capital;
                    }
                    if (bundleSheet.fields[`${cerfa.percentageField}${keyExtension}`]) {
                        bundleSheet.fields[`${cerfa.percentageField}${keyExtension}`].value =
                            percentage;
                    }
                    // birth
                    if (
                        bundleSheet.fields[`${cerfa.birdthDateField}${keyExtension}`] &&
                        associate.birthDate
                    ) {
                        bundleSheet.fields[`${cerfa.birdthDateField}${keyExtension}`].value =
                            moment(associate.birthDate).format("DD/MM/YYYY");
                        const birthData = {
                            "@E": associate.birthDepartment,
                            "@F": associate.birthPlace,
                            "@G": associate.birthCountry,
                        };
                        for (const key in birthData) {
                            const field =
                                bundleSheet.fields[
                                    `${cerfa.currentCerfa.births[cerfa.index]}_${key}`
                                ];
                            if (field && birthData[key]) {
                                field.value = birthData[key];
                            }
                        }
                    }
                }
                cerfa.index++;
            }
        }
    }

    async setDefaultCompanyAssociate({
        associates,
        prefixKeys,
        baseFormPage,
        extensionPage,
        additionalFields,
    }: {
        associates: any[];
        prefixKeys: {
            addressField: string;
        };
        baseFormPage: string;
        extensionPage: string;
        additionalFields?: ({
            currentForm,
            keyExtension,
            associate,
        }: {
            currentForm: string;
            keyExtension: string;
            associate: any;
            associateIndex: number;
        }) => Promise<{
            currentForm?: string;
        } | void>;
    }) {
        let currentForm = baseFormPage;
        let index = 0;
        for (const associateIndex in associates) {
            if (!this.bundleSheets[currentForm]) {
                await this.createAdditionalPage(currentForm);
            }
            const associate = associates[associateIndex];
            let keyExtension = "";
            if (
                !this.bundleSheets[currentForm].fields[`${prefixKeys.addressField}${keyExtension}`]
            ) {
                let newForm = (await this.createAdditionalPage(extensionPage)).name;
                currentForm = newForm;
                index = 0;
                keyExtension = "";
            }
            if (additionalFields) {
                const result = await additionalFields({
                    currentForm,
                    keyExtension,
                    associate,
                    associateIndex: +associateIndex,
                });
                if (result) {
                    if (result?.currentForm) {
                        currentForm = result.currentForm;
                    }
                }
            }
            index++;
        }
    }

    setCompanyProfessionalRegimeAssociate(associates) {
        const additionalFields = async ({
            currentForm,
            keyExtension,
            associate,
            associateIndex,
        }) => {
            // Récupération du mapping des champs
            let { data, page, repeat } =
                this.SCICorrespondenceTable.import[4].importCodification.find(
                    (form) =>
                        form.lineStart <= associateIndex + 1 && form.lineEnd >= associateIndex + 1
                );

            // Remplissage des champs en fonction du 'name' dans le mapping
            for (const d of data) {
                if (repeat) {
                    const repeatNumber = Math.floor(associateIndex / 3) + 1;
                    if (
                        !this.bundleSheets[`${page}${repeatNumber === 2 ? "" : "_" + repeatNumber}`]
                    ) {
                        page = (await this.createAdditionalPage(page)).name;
                    } else {
                        page = currentForm;
                    }
                }

                switch (d.name) {
                    case "legalPersonGlobalIdentity": {
                        if (associate.type !== "LEGAL_PERSON") {
                            break;
                        }
                        const [streetNumber, btq, street] = this.extractNumberAndBtq(
                            associate.address
                        );
                        const address = {
                            "@A": streetNumber,
                            "@B": btq,
                            "@C": street,
                            "@D": associate.addressComplement,
                            "@E": associate.postalCode,
                            "@F": associate.city,
                            "@G": associate.country,
                            "@I": associate.lastname,
                            "@J": associate.firstname,
                            "@L": associate.taxNumber,
                        };
                        for (const key in address) {
                            const fieldAddress =
                                this.bundleSheets[page].fields[
                                    `${d.cell[associateIndex % 3]}_${key}`
                                ];
                            if (fieldAddress && address[key]) {
                                fieldAddress.value = address[key];
                            }
                        }
                        break;
                    }
                    default: {
                        // DO NOTHING
                    }
                }
            }

            return {
                currentForm: page,
            };
        };
        this.setDefaultCompanyAssociate({
            associates,
            prefixKeys: {
                addressField: "AH",
            },
            baseFormPage: "2072SA22",
            extensionPage: "2072SA22X1",
            additionalFields,
        });
    }

    setCompanyLandTenureAssociate(associates, accountingEnd) {
        const accountingPeriodEnd = moment(accountingEnd).format("YYYY-MM-DD");
        const additionalFields = async ({
            currentForm,
            keyExtension,
            associate,
            associateIndex,
        }) => {
            // Récupération du mapping des champs
            let { data, page, repeat } =
                this.SCICorrespondenceTable.import[3].importCodification.find(
                    (form) =>
                        form.lineStart <= associateIndex + 1 && form.lineEnd >= associateIndex + 1
                );

            // Remplissage des champs en fonction du 'name' dans le mapping
            for (const d of data) {
                if (repeat) {
                    const repeatNumber = Math.floor(associateIndex / 3) + 1;
                    if (
                        !this.bundleSheets[`${page}${repeatNumber === 2 ? "" : "_" + repeatNumber}`]
                    ) {
                        page = (await this.createAdditionalPage(page)).name;
                    } else {
                        page = currentForm;
                    }
                }
                switch (d.name) {
                    case "legalPersonGlobalIdentity": {
                        if (associate.type !== "LEGAL_PERSON") {
                            break;
                        }
                        const [streetNumber, btq, street] = this.extractNumberAndBtq(
                            associate.address
                        );
                        const address = {
                            "@A": streetNumber,
                            "@B": btq,
                            "@C": street,
                            "@D": associate.addressComplement,
                            "@E": associate.postalCode,
                            "@F": associate.city,
                            "@G": associate.country,
                            "@H": associate.legalForm,
                            "@I": associate.lastname,
                            "@L": associate.siret,
                        };
                        for (const key in address) {
                            const fieldAddress =
                                this.bundleSheets[page].fields[
                                    `${d.cell[associateIndex % 3]}_${key}`
                                ];
                            if (fieldAddress && address[key]) {
                                fieldAddress.value = address[key];
                            }
                        }
                        break;
                    }
                    case "naturalPersonGlobalIdentity": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const [streetNumber, btq, street] = this.extractNumberAndBtq(
                            associate.address
                        );
                        const address = {
                            "@A": streetNumber,
                            "@B": btq,
                            "@C": street,
                            "@D": associate.addressComplement,
                            "@E": associate.postalCode,
                            "@F": associate.city,
                            "@G": associate.country,
                            "@I": associate.lastname,
                            "@J": associate.firstname,
                            "@L": associate.taxNumber,
                        };
                        for (const key in address) {
                            const fieldAddress =
                                this.bundleSheets[page].fields[
                                    `${d.cell[associateIndex % 3]}_${key}`
                                ];
                            if (fieldAddress && address[key]) {
                                fieldAddress.value = address[key];
                            }
                        }
                        break;
                    }
                    case "naturalPersonBirthday": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const fieldBirthday =
                            this.bundleSheets[page].fields[`${d.cell[associateIndex % 3]}`];
                        if (fieldBirthday) {
                            fieldBirthday.value =
                                moment(associate.birthDate).format("DD/MM/YYYY") || "";
                        }
                        break;
                    }
                    case "naturalPersonBirthPlace": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const birthPlace = {
                            "@E": associate.birthDepartment,
                            "@F": associate.birthPlace,
                            "@G": associate.birthCountry,
                        };
                        for (const key in birthPlace) {
                            const fieldBirthPlace =
                                this.bundleSheets[page].fields[
                                    `${d.cell[associateIndex % 3]}_${key}`
                                ];
                            if (fieldBirthPlace && birthPlace[key]) {
                                fieldBirthPlace.value = birthPlace[key];
                            }
                        }
                        break;
                    }
                    case "fullOwnershipSharesQuantity": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const fieldShares =
                            this.bundleSheets[page].fields[`${d.cell[associateIndex % 3]}`];
                        if (fieldShares) {
                            let shares = 0;
                            // before, eliminate shares with date above accounting period end
                            const filteredShares = associate.shares.filter(
                                (share) => share.date <= accountingPeriodEnd
                            );
                            if (filteredShares.length) {
                                const sortedShares = filteredShares.sort(sortSharesByDate);
                                shares = sortedShares[0].quantity;
                            }
                            fieldShares.value = shares;
                        }
                        break;
                    }
                    case "nominalSharesAmount": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const fieldNominal =
                            this.bundleSheets[page].fields[`${d.cell[associateIndex % 3]}`];
                        if (fieldNominal) {
                            let nominal = 0;
                            const filteredShares = associate.shares.filter(
                                (share) => share.date <= accountingPeriodEnd
                            );
                            if (filteredShares.length) {
                                const sortedShares = filteredShares.sort(sortSharesByDate);
                                nominal = sortedShares[0].amount;
                            }
                            fieldNominal.value = nominal;
                        }
                        break;
                    }
                    case "bareOwnershipSharesQuantity": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const fieldBare =
                            this.bundleSheets[page].fields[`${d.cell[associateIndex % 3]}`];
                        if (fieldBare) {
                            let bare = 0;
                            const filteredTitles = associate.titles.filter(
                                (title) =>
                                    title.date <= accountingPeriodEnd && title.bareOwnershipShares
                            );
                            if (filteredTitles.length) {
                                const sortedTitles = filteredTitles.sort(sortSharesByDate);
                                bare = sortedTitles[0].bareOwnershipShares;
                            }
                            fieldBare.value = bare;
                        }
                        break;
                    }
                    case "usufructSharesQuantity": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const fieldUsufruct =
                            this.bundleSheets[page].fields[`${d.cell[associateIndex % 3]}`];
                        if (fieldUsufruct) {
                            const filteredTitles = associate.titles.filter(
                                (title) => title.date <= accountingPeriodEnd && title.usufructShares
                            );
                            let usufruct = 0;
                            if (filteredTitles.length) {
                                const sortedTitles = filteredTitles.sort(sortSharesByDate);
                                usufruct = sortedTitles[0].usufructShares;
                            }
                            fieldUsufruct.value = usufruct;
                        }
                        break;
                    }
                    case "usufructHolderReference": {
                        if (associate.type !== "NATURAL_PERSON") {
                            break;
                        }
                        const fieldUsufructHolder =
                            this.bundleSheets[page].fields[`${d.cell[associateIndex % 3]}`];
                        if (fieldUsufructHolder) {
                            let usufructHolder = "";
                            if (associate.usufructHolder) {
                                usufructHolder = associate.usufructHolder;
                            }
                            fieldUsufructHolder.value = usufructHolder;
                        }
                        break;
                    }
                    default: {
                        // DO NOTHING
                    }
                }
            }

            return {
                currentForm: page,
            };
        };

        this.setDefaultCompanyAssociate({
            associates,
            prefixKeys: {
                addressField: "AC",
            },
            baseFormPage: "2072SA21",
            extensionPage: "2072SA2EX1",
            additionalFields,
        });
    }

    async getDeclarationForm({ year, cerfa }) {
        try {
            const form = await this.getDeclarationFormQuery({ year, cerfa });
            return { ...form, year };
        } catch (error) {
            console.error("Error getting declaration form", error);
            return null;
        }
    }

    async getBookletTemplates() {
        const bookletTemplates = await this.getBookletTemplatesQuery();
        if (this.bookletTemplate?.id) {
            const bookletTemplate = bookletTemplates?.find(
                (bt) => bt.id === this.bookletTemplate.id
            );
            if (bookletTemplate) {
                this.bookletTemplate = bookletTemplate;
            }
        }
        if (bookletTemplates) {
            return bookletTemplates;
        }
        return [];
    }

    compareBalances(accountingBalance) {
        let errors: any = {
            missingAasInAccountingBalance: [],
            aasWithdifferentBalance: [],
            missingAasInBundleBalance: [],
        };

        let bundleAas = [];

        for (const aa of this.balances) {
            bundleAas.push(aa.key);
            const foundAa = accountingBalance.find((accAa) => accAa.key === aa.key);
            if (!foundAa) {
                errors.missingAasInAccountingBalance.push(aa.name + " " + aa.description);
                errors.aasWithdifferentBalance.push({
                    aaName: aa.name + " " + aa.description,
                    bundleGlBalance: aa.balance,
                    aaAccountingBalance: 0,
                    id: aa.id,
                });
            } else {
                if (isAccountingZero(aa.balance - foundAa.balance)) {
                    continue;
                } else {
                    errors.aasWithdifferentBalance.push({
                        aaName: aa.name + " " + aa.description,
                        bundleGlBalance: aa.balance,
                        aaAccountingBalance: foundAa.balance,
                        id: aa.id,
                    });
                }
            }
        }

        for (const accAa of accountingBalance) {
            if (!bundleAas.find((aa) => aa === accAa.key)) {
                errors.missingAasInBundleBalance.push(accAa.name + " " + accAa.description);
                errors.aasWithdifferentBalance.push({
                    aaName: accAa.name + " " + accAa.description,
                    bundleGlBalance: 0,
                    aaAccountingBalance: accAa.balance,
                    id: accAa.id,
                });
            }
        }

        return errors;
    }

    async generateSheets() {
        if (this.bundleN1) {
            this.bundleN1.generateSheets();
        }
        this.bundleSheets = {};
        let loadPagePromises: Promise<SheetManager>[] = [];
        if (!this.bundle) {
            const mandatoryPages = this.mandatoryPages();
            for (const form of mandatoryPages) {
                if (form.forms) {
                    for (const subForm of form.forms) {
                        loadPagePromises.push(
                            this.addBundleSheet(
                                {
                                    id: "",
                                    cerfa: subForm.cerfa,
                                    year: this.year,
                                },
                                false
                            )
                        );
                    }
                    continue;
                }
                loadPagePromises.push(
                    this.addBundleSheet(
                        {
                            id: "",
                            cerfa: form.cerfa,
                            year: this.year,
                        },
                        false
                    )
                );
            }
        } else {
            if (!this.bundle?.bundleSheets?.length) {
                return;
            }

            for (const sheet of this.bundle.bundleSheets) {
                const allJson = {
                    ...sheet.form.form,
                    id: sheet.form.id,
                    image: sheet.image || sheet.form.image,
                    year: sheet.form.year,
                };
                // to initialize the repeat number if needed
                if (!this.bundleSheets[sheet.form.cerfaNumber]) {
                    loadPagePromises.push(
                        this.addBundleSheet(
                            new SheetManager(
                                sheet.id,
                                allJson,
                                this.radicals,
                                this,
                                null,
                                false,
                                sheet.data
                            ),
                            false,
                            true,
                            true
                        )
                    );
                } else {
                    let additionalPageNumber = 2;
                    while (
                        !!this.bundleSheets[`${sheet.form.cerfaNumber}_${additionalPageNumber}`]
                    ) {
                        additionalPageNumber++;
                    }
                    loadPagePromises.push(
                        this.addBundleSheet(
                            new SheetManager(
                                sheet.id,
                                allJson,
                                this.radicals,
                                this,
                                null,
                                false,
                                sheet.data,
                                additionalPageNumber
                            ),
                            false,
                            true,
                            true
                        )
                    );
                }
                //
            }
        }
        if (loadPagePromises.length) {
            await Promise.all(loadPagePromises);
        }
    }

    async loadAnnexes(update: boolean) {
        const annexeForms = [];

        if (this.bookletTemplate?.content?.pages.length) {
            for (const annex of this.bookletTemplate?.content?.pages) {
                if (
                    BOOKLET_ANNEXES_LIST_FORMS.findIndex((form) => form.cerfa === annex.cerfa) !==
                    -1
                ) {
                    if (!this.bundleSheets[annex.cerfa]) {
                        annexeForms.push(annex.cerfa);
                    } else if (this.bundleN1 && !this.bundleN1.bundleSheets[annex.cerfa]) {
                        annexeForms.push(annex.cerfa);
                    }
                }
            }
        }
        if (annexeForms.length) {
            const forms = await this.getDeclarationFormsQuery({
                year: this.year,
                cerfas: annexeForms,
            });
            if (forms?.length) {
                if (this.bundleN1) {
                    await this.bundleN1.loadAnnexes_(forms);
                }
                await this.loadAnnexes_(forms);
                if (update) {
                    this.updateDependencies();
                    this.update();
                }
            }
        }
    }

    async loadAnnexes_(forms) {
        const loadPagePromises = [];
        for (const form of forms) {
            if (!this.bundleSheets[form.cerfaNumber]) {
                loadPagePromises.push(
                    this.addBundleSheet(
                        new SheetManager("", form, this.radicals, this, null, false, form?.values),
                        false
                    )
                );
            }
        }
        if (loadPagePromises.length) {
            await Promise.all(loadPagePromises);
        }
    }

    generateRadicals() {
        if (this.bundleN1) {
            this.bundleN1.generateRadicals();
        }
        this.radicals = this._generateRadicals(this.balances);
    }

    _generateRadicals(balances, inPLR = null): { [k: string]: number } {
        if (balances) {
            const plr = inPLR || this.plr;
            plr.sort((a, b) => {
                if (a.account.length < b.account.length) return 1;
                if (a.account.length > b.account.length) return -1;
                return 0;
            });
            let plrResult = {};
            this.radicalsComposition = {};

            // let errorValues = [];

            for (let plrAcc of plr) {
                if (plrAcc.debit) {
                    plrResult[plrAcc.debit] = 0;
                }
                if (plrAcc.credit) {
                    plrResult[plrAcc.credit] = 0;
                }
            }

            let consoleBalance = true;

            for (const glAccount of balances) {
                const balance = glAccount.balance || 0;
                if (!balance) {
                    continue;
                }
                // let radical = plr.find((plr) => glAccount.name.startsWith(plr.account));
                // let radical

                let found = false;
                // let affected = false
                for (const radical of plr) {
                    if (!glAccount.name.startsWith(radical.account)) {
                        continue;
                    }
                    found = true;
                    if (!this.radicalsComposition[radical.debit]) {
                        this.radicalsComposition[radical.debit] = [];
                    }
                    if (!this.radicalsComposition[radical.credit]) {
                        this.radicalsComposition[radical.credit] = [];
                    }

                    if (radical.debit && radical.credit) {
                        if (balance > 0) {
                            if (consoleBalance)
                                console.log(
                                    `DEBIT= ${radical.account + "-" + radical.debit}: name= ${
                                        glAccount.name
                                    } ${glAccount.thirdPartyCompanyName || ""} balance=${balance} `
                                );
                            this.radicalsComposition[radical.debit].push({
                                name: glAccount.name,
                                balance: balance,
                                description: glAccount.description,
                            });
                            plrResult[radical.debit] += balance;
                        } else {
                            if (consoleBalance)
                                console.log(
                                    `CREDIT= ${radical.account + "-" + radical.credit}: name= ${
                                        glAccount.name
                                    } ${glAccount.thirdPartyCompanyName || ""} balance=${-balance} `
                                );
                            this.radicalsComposition[radical.credit].push({
                                name: glAccount.name,
                                balance: -balance,
                                description: glAccount.description,
                            });
                            plrResult[radical.credit] -= balance;
                        }
                    } else if (radical.debit) {
                        if (balance > 0) {
                            if (consoleBalance)
                                console.log(
                                    `DEBIT= ${radical.account + "-" + radical.debit}: name= ${
                                        glAccount.name
                                    } ${glAccount.thirdPartyCompanyName || ""} balance=${balance} `
                                );
                            this.radicalsComposition[radical.debit].push({
                                name: glAccount.name,
                                balance: balance,
                                description: glAccount.description,
                            });
                            plrResult[radical.debit] += balance;
                        } else {
                            if (consoleBalance)
                                console.log(
                                    `DEBIT= ${radical.account + "-" + radical.debit}: name= ${
                                        glAccount.name
                                    } ${glAccount.thirdPartyCompanyName || ""} balance=${-balance} `
                                );
                            this.radicalsComposition[radical.debit].push({
                                name: glAccount.name,
                                balance: -balance,
                                description: glAccount.description,
                            });
                            plrResult[radical.debit] += balance;
                        }
                    } else if (radical.credit) {
                        if (balance < 0) {
                            // affected = true
                            if (consoleBalance)
                                console.log(
                                    `CREDIT= ${radical.account + "-" + radical.credit}: name= ${
                                        glAccount.name
                                    } ${glAccount.thirdPartyCompanyName || ""} balance=${-balance} `
                                );
                            this.radicalsComposition[radical.credit].push({
                                name: glAccount.name,
                                balance: -balance,
                                description: glAccount.description,
                            });
                            plrResult[radical.credit] -= balance;
                        } else {
                            if (consoleBalance)
                                console.log(
                                    `CREDIT= ${radical.account + "-" + radical.credit}: name= ${
                                        glAccount.name
                                    } ${glAccount.thirdPartyCompanyName || ""} balance=${balance} `
                                );
                            this.radicalsComposition[radical.credit].push({
                                name: glAccount.name,
                                balance: balance,
                                description: glAccount.description,
                            });
                            plrResult[radical.credit] -= balance;
                        }
                    }
                    if (found) {
                        break;
                    }
                }
                if (!found) {
                    this.unaffectedAccounts.push(glAccount);
                    console.error(`unaffected account : ${glAccount.name}`);
                }
            }

            for (const key in this.radicalsComposition) {
                for (const rd of this.radicalsComposition[key]) {
                    rd.balance = mathFix(rd.balance);
                }
            }

            for (const key in plrResult) {
                plrResult[key] = mathFix(plrResult[key]);
            }
            return plrResult;
        }
        return {};
    }

    async addBundleSheet(
        sheet: SheetManager | { id: string; cerfa: string; year: string },
        updateDependencies: boolean,
        allowDuplicate: boolean = true,
        loading: boolean = false
    ) {
        // Romain
        let newBundleManager: SheetManager;
        let additionalPageNumber = 2;
        if (sheet instanceof SheetManager) {
            newBundleManager = sheet;
        } else {
            const declarationForm = await this.getDeclarationForm(sheet);
            if (!declarationForm) {
                debugger;
                console.error({
                    type: "error",
                    message: `No declaration form found for ${sheet.cerfa} in ${sheet.year}`,
                });
                return;
            }
            if (!this.bundleSheets[sheet.cerfa]) {
                newBundleManager = new SheetManager(
                    sheet.id,
                    declarationForm,
                    this.radicals,
                    this,
                    null,
                    false,
                    undefined,
                    undefined
                );
            } else {
                if (!allowDuplicate) {
                    return;
                }
                while (!!this.bundleSheets[`${sheet.cerfa}_${additionalPageNumber}`]) {
                    additionalPageNumber++;
                }
                newBundleManager = new SheetManager(
                    sheet.id,
                    declarationForm,
                    this.radicals,
                    this,
                    null,
                    false,
                    undefined,
                    additionalPageNumber
                );
            }
        }

        if (!this.bundleSheets[newBundleManager.cerfaNumber]) {
            this.bundleSheets[newBundleManager.cerfaNumber] = newBundleManager;
        } else {
            if (
                loading &&
                BOOKLET_ANNEXES_LIST_FORMS.findIndex(
                    (form) => form.cerfa === newBundleManager.cerfaNumber
                ) !== -1 &&
                newBundleManager.cerfaNumber?.startsWith("A") &&
                this.bundleSheets[newBundleManager.cerfaNumber]
            ) {
                console.error("doublon = ", newBundleManager.cerfaNumber);
                if (newBundleManager.id) {
                    await this.deleteBundleSheetQuery(newBundleManager.id);
                }
                // delete newBundleManager
                return;
            }
            // to avoid erase existing sheet in case of "sheet instance of sheetManager" and more of two sheets with the same cerfa number
            while (!!this.bundleSheets[`${newBundleManager.cerfaNumber}_${additionalPageNumber}`]) {
                additionalPageNumber++;
            }
            //
            this.bundleSheets[`${newBundleManager.cerfaNumber}_${additionalPageNumber}`] =
                newBundleManager;
            // if (!this.multipleBundleSheets[newBundleManager.cerfaNumber]) {
            //     this.multipleBundleSheets[newBundleManager.cerfaNumber] = []
            // }
            // this.multipleBundleSheets[newBundleManager.cerfaNumber].push(newBundleManager)
        }

        if (updateDependencies) {
            this.updateDependencies();
            this.update();
        }

        return newBundleManager;
    }

    async createAdditionalPage(cerfa: string) {
        return await this.addBundleSheet({ id: "", year: this.year, cerfa }, true);
    }

    updateDependencies() {
        if (this.bundleN1) {
            this.bundleN1.updateDependencies();
            this.propagateBundleN1Fields();
        }

        for (const key in this.bundleSheets) {
            const sheet = this.bundleSheets[key];
            sheet.updateDependencies(this.specs);
        }

        if (this.consistencyChecksManager) {
            this.consistencyChecksManager.updateDependencies(this.specs);
        }
    }

    propagateBundleN1Fields() {
        if (this.bundleN1) {
            for (const key in this.bundleN1.specs) {
                this.specs[`N1:${key}`] = this.bundleN1.specs[key];
            }
            for (const cerfaNumber in this.bundleN1.bundleSheets) {
                const sheet = this.bundleSheets[cerfaNumber];
                if (sheet) {
                    const sheetN1 = this.bundleN1.bundleSheets[cerfaNumber];
                    sheet.setSheetN1(sheetN1);
                }
            }
        }
    }

    update() {
        if (this.bundleN1) {
            this.bundleN1.update();
        }
        for (const key in this.bundleSheets) {
            const sheet = this.bundleSheets[key];
            sheet.update();
        }
        if (this.consistencyChecksManager) {
            this.consistencyChecksManager.update();
        }
    }

    get mandatoryForms() {
        const { ogaEnrolment } = this.settingsVariables;
        return this.formsList.filter(
            (form: any) =>
                (form.type === "main-form" && !form.cerfa.includes("OG")) ||
                (form.type === "multiple-page" &&
                    !form.cerfa.includes("OG") &&
                    form.forms.every((subForm: any) => subForm.type === "main-form")) ||
                (ogaEnrolment &&
                    (this.bundleType === "BICRSP" ||
                        this.bundleType === "BICRNP" ||
                        this.bundleType === "BNC" ||
                        this.bundleType === "BARNA") &&
                    form.cerfa.includes("OG"))
        );
    }

    isMandatoryForm(cerfaNumber: string) {
        return this.mandatoryForms.some(
            (form: any) =>
                form.cerfa === cerfaNumber ||
                (form.forms && form.forms.some((subForm: any) => subForm.cerfa === cerfaNumber))
        );
    }

    mandatoryPages() {
        const mandatoryPages: any = [];
        for (const form of this.mandatoryForms) {
            if (form.forms) {
                for (const subForm of form.forms) {
                    mandatoryPages.push(subForm);
                }
                continue;
            }
            mandatoryPages.push(form);
        }
        return mandatoryPages;
    }

    optionalForms() {
        return this.formsList.filter(
            (form: any) =>
                form.type === "sub-form" ||
                (form.type === "multiple-page" &&
                    form.forms.every((subForm: any) => subForm.type === "sub-form"))
        );
    }

    getValue(key) {
        if (this.specs?.[key]?.value) {
            return this.specs[key].value;
        }
        return;
    }

    get referencedSheets() {
        const referencedSheets: any[] = [];
        let professionalRegimeAssociatesCount = 0;
        let landTenureAssociatesCount = 0;
        if (this.bundleType === "SCI" && this.associates.length) {
            const groupedAssociates: { [key: string]: any[] } = groupBy(
                this.associates,
                "partnerType"
            );
            professionalRegimeAssociatesCount =
                (groupedAssociates["professionalRegimeAssociate"]?.length ?? 0) +
                (groupedAssociates["null"]?.length ?? 0);
            landTenureAssociatesCount = groupedAssociates["landTenureAssociate"]?.length ?? 0;
        }
        for (const key in this.bundleSheets) {
            if (this.bundleType === "SCI") {
                // do not create the 2072SA21 bundlesheet if not necessary
                if (key === "2072SA21") {
                    if (landTenureAssociatesCount > 0) {
                        referencedSheets.push(this.bundleSheets[key]);
                    }
                    // do not create the 2072SA22 bundlesheet if not necessary
                } else if (key === "2072SA22") {
                    if (professionalRegimeAssociatesCount > 0) {
                        referencedSheets.push(this.bundleSheets[key]);
                    }
                    // do not create the 2072SA2 bundlesheet to avoid duplicate with 2072SA21 and 2072SA22
                } else if (key !== "2072SA2") {
                    referencedSheets.push(this.bundleSheets[key]);
                }
            } else {
                referencedSheets.push(this.bundleSheets[key]);
            }
        }
        const sortingBase = this.sortingBased;
        if (sortingBase) {
            referencedSheets.sort(
                (a, b) => sortingBase.indexOf(a.cerfaNumber) - sortingBase.indexOf(b.cerfaNumber)
            );
        }
        return referencedSheets;
    }

    // getReferencedSheets1() {
    //     let referencedCerfa: string[] = Object.keys(this.bundleSheets);
    //     let referencedSheets: any[] = [];
    //     // console.log(this.bundleSheets)
    //     // console.log(this.formsList)
    //     for (const sheetName of referencedCerfa) {
    //         const cerfa = sheetName.split("_")[0];
    //         if (this.isComplementaryForm(cerfa)) {
    //             const form = this.getComplementaryForm(cerfa)
    //             const formToPush = JSON.parse(JSON.stringify(form))
    //             formToPush.cerfa = sheetName
    //             referencedSheets.push(formToPush);
    //             continue
    //         }

    //         const sheet = this.formsList.find(
    //             (form: any) =>
    //                 form.cerfa === cerfa ||
    //                 (form.forms && form.forms.find((subForm: any) => subForm.cerfa === cerfa))
    //         );
    //         if (!sheet) {
    //             debugger
    //         }
    //         if (this.bundleType === "SCI") { // Il faut appliquer cette logique uniquement pour les SCI, ne pas l'appliquer pour les autres types de bundles
    //             let specificSheet = undefined
    //             if (sheet) {
    //                 if (sheet?.type === "multiple-page") {
    //                     specificSheet = sheet.forms.find((form) => form.cerfa === cerfa)
    //                 }
    //                 if (specificSheet) {
    //                     referencedSheets.push(specificSheet);
    //                 } else {
    //                     referencedSheets.push(sheet);
    //                 }
    //             }
    //         } else {
    //             if (sheet) {
    //                 referencedSheets.push(sheet);
    //                 // if (sheet?.complementForm?.length) {
    //                 //     referencedSheets.push(...sheet.complementForm)
    //                 // }
    //             }
    //         }
    //     }

    //     const index1330CVAE = referencedSheets.findIndex(form => form.cerfa === "1330CVAE")

    //     if (index1330CVAE > -1) {
    //         referencedSheets.splice(index1330CVAE, 1)
    //     }

    //     const index2035SA = referencedSheets.findIndex(form => form.cerfa === "2035SUITE")

    //     if (index2035SA > -1) {
    //         referencedSheets.splice(index2035SA, 1)
    //     }

    //     const index2065BIS = referencedSheets.findIndex(form => form.cerfa === "2065BIS")

    //     if (index2065BIS > -1) {
    //         referencedSheets.splice(index2065BIS, 1)
    //     }

    //     const index2069RCI = referencedSheets.findIndex(form => form.cerfa === "2069RCI")

    //     if (index2069RCI > -1) {
    //         referencedSheets.splice(index2069RCI, 1)
    //     }

    //     return referencedSheets
    //     // return uniqBy(referencedSheets, "cerfa");
    // }

    get sortingBased() {
        let sortingBase = [];

        for (const form of this.formsList) {
            sortingBase.push(form.cerfa);
            if (form.forms) {
                for (const subform of form.forms) {
                    sortingBase.push(subform.cerfa);
                    if (subform.complementForm) {
                        for (const cf of subform.complementForm) {
                            sortingBase.push(cf.cerfa);
                        }
                    }
                }
            }
            if (form.complementForm) {
                for (const cf of form.complementForm) {
                    sortingBase.push(cf.cerfa);
                }
            }
        }
        return sortingBase;
    }

    get complementaryForms(): any {
        let complementaryForms = [];
        for (const form of this.formsList) {
            if (form.complementForm) {
                for (const cf of form.complementForm) {
                    complementaryForms.push(cf);
                }
            } else if (form.forms) {
                for (const subform of form.forms) {
                    if (subform.complementForm) {
                        for (const cf of subform.complementForm) {
                            complementaryForms.push(cf);
                        }
                    }
                }
            }
        }
        return complementaryForms;
        // return BNC_LIST_FORMS.flatMap((form: any) => {
        //     if (form.type === "multiple-page") {
        //         return form.forms?.flatMap((subForm: any) => subForm.complementForm);
        //     }
        //     return form.complementForm;
        // });
    }

    isComplementaryForm(cerfa: string) {
        return !!this.getComplementaryForm(cerfa);
    }

    getComplementaryForm(cerfa: string) {
        return this.complementaryForms.find((x) => x.cerfa === cerfa);
    }

    generateConsistencyChecks() {
        this.consistencyChecksManager = new ConsistencyChecksManager(
            this,
            this.consistencyChecksList,
            this.radicals
        );
        // let consistencySpecs = this.consistencyChecksManager.getChecks();

        // let fields = {};
        // for (const [key, value] of Object.entries(consistencySpecs)) {
        //     fields[`CONSISTENCY:${key}`] = value;
        // }
        // ERIC N A PAS FINI : PAIN AU CHOCOLAT
        // Et du coup ? On les a quand ?
        // let payload = {
        //     fields: consistencySpecs,
        //     fromDependencies: this.consistencyChecksManager.getFromDependencies(),
        //     callback: (field, spec) => this.consistencyChecksManager.addExternalFields(field, spec),
        // };
        // this.updateFields(payload);
    }

    getBundleSheets(cerfa: string) {
        let bundleSheet = this.bundleSheets[cerfa];
        if (bundleSheet) {
            return bundleSheet;
        }
        let form = this.formsList.find((form: any) => form.cerfa === cerfa);
        if (!form?.forms?.length) {
            return null;
        }
        let bundleSheets = form.forms.map((subForm: any) => this.bundleSheets[subForm.cerfa]);
        return bundleSheets;
    }

    getRadicalComposition(radNumber: string) {
        return [...(this.radicalsComposition[radNumber] || [])];
    }

    getRadicalList(radicals) {
        const list = [];
        if (this.plr) {
            for (const rad of radicals) {
                const found = this.plr.filter((x) => x.debit === rad || x.credit === rad);
                list.push(...found);
                list.sort((a, b) => {
                    return a.account?.localeCompare(b.account);
                });
            }
        } else {
            debugger;
        }
        return list;
    }

    async deleteSheet(bundleSheet: SheetManager) {
        if (!bundleSheet) {
            debugger;
            return;
        }

        if (bundleSheet.id) {
            await this.deleteBundleSheetQuery(bundleSheet.id);
            for (const key in this.bundleSheets) {
                if (this.bundleSheets[key].id === bundleSheet.id) {
                    delete this.bundleSheets[key];
                    break;
                }
            }
        } else {
            for (const key in this.bundleSheets) {
                if (key === bundleSheet.name) {
                    delete this.bundleSheets[key];
                    break;
                }
            }
        }

        // const bundleSheets = []

        // const form = this.formsList.find(
        //     (form: any) =>
        //         (form.forms && form.forms.find((subForm: any) => subForm.cerfa === bundleSheet.cerfaNumber))
        // );
        // if (form?.forms?.length) {
        //     for (const subForm of form.forms) {
        //         const sheet = this.bundleSheets[subForm.cerfa]
        //         if (sheet) {
        //             bundleSheets.push(sheet)
        //         }

        //     }
        // } else {
        //     bundleSheets.push(bundleSheet)
        // }

        // for (const sheet of bundleSheets) {
        //     if (bundleSheet.id) {
        //         await this.deleteBundleSheetQuery(sheet.id)
        //     }
        //     if (this.bundleSheets[sheet.cerfaNumber]) {
        //         delete this.bundleSheets[sheet.cerfaNumber];
        //     } else {
        //         debugger
        //         return
        //     }
        // }
    }

    generateAAClassesBalanceSum() {
        let aaClassesBalanceSum = {};
        for (const aa of this.balances) {
            const aaClass = aa.name.slice(0, 6);
            if (!aaClassesBalanceSum[aaClass]) {
                aaClassesBalanceSum[aaClass] = 0;
            }
            aaClassesBalanceSum[aaClass] += aa.balance;
        }
        for (const key in aaClassesBalanceSum) {
            aaClassesBalanceSum[key] = mathFix(aaClassesBalanceSum[key]);
        }

        const result = {};
        Object.entries(aaClassesBalanceSum).forEach(([key, amount]) => {
            for (let i = key.length; i > 0; i--) {
                const reducedKey = key.substring(0, i);
                result[reducedKey] = (result[reducedKey] || 0) + amount;
            }
        });
        //
        this.aaClassesBalanceSum = result;
        if (this.bundleN1) {
            this.bundleN1.generateAAClassesBalanceSum();
        }
        // return result
    }

    checkAccountsBalance(generalLedgerToCheck: GeneralLedgerAccountType[]) {
        let formatedGeneralLedger: GeneralLedgerAccountType[] = [];
        for (const account in generalLedgerToCheck) {
            const { name, balance } = generalLedgerToCheck[account];
            const shortName: string = name.substring(0, 3);
            formatedGeneralLedger.push({ name, shortName, balance });
        }
        const accountsMustBeDebtorOrZero = ["119", "409", "418", "486", "511", "530"];
        const accountsMustBeCreditorOrZero = ["101", "110", "164", "408", "419", "487"];
        const accountsMustBeZero = ["120", "129", "471"];
        const accountsToCheck = [
            ...accountsMustBeDebtorOrZero,
            ...accountsMustBeCreditorOrZero,
            ...accountsMustBeZero,
        ];
        let generalLedgerWithChecks: GeneralLedgerAccountType[] = [...formatedGeneralLedger].filter(
            (account) => accountsToCheck.includes(account.shortName)
        );
        for (const i in generalLedgerWithChecks) {
            const account = generalLedgerWithChecks[i];
            if (
                accountsMustBeDebtorOrZero.includes(account.shortName) &&
                checkIfCloseToZero(account.balance) < 0
            ) {
                account.isAbnormal = true;
                account.anomaly = `Le solde doit être débiteur`;
            } else if (
                accountsMustBeCreditorOrZero.includes(account.shortName) &&
                checkIfCloseToZero(account.balance) > 0
            ) {
                account.isAbnormal = true;
                account.anomaly = `Le solde doit être créditeur`;
            } else if (
                accountsMustBeZero.includes(account.shortName) &&
                checkIfCloseToZero(account.balance) !== 0
            ) {
                account.isAbnormal = true;
                account.anomaly = `Le solde doit être nul`;
            }
        }
        const anomalies = generalLedgerWithChecks.filter((account) => account.isAbnormal === true);
        return anomalies;
    }

    extractNumberAndBtq(address: string): [string, string, string] {
        const numberBtqStreet: { number: string; btq: string; street: string } =
            extractNumberBtqStreet(address);
        const number: string = numberBtqStreet?.number || "";
        const btq: string = numberBtqStreet?.btq || "";
        const street: string = numberBtqStreet?.street || "";
        return [number, btq, street];
    }

    get isSent() {
        if (this.bundle?.date) {
            // it is the send date
            return true;
        }
        return false;
    }

    checkTaxNumberSCIAssociates(taxSystemType) {
        if (this.bundleType === "SCI" && taxSystemType === "IR" && this.associates.length) {
            for (const associate of this.associates) {
                if (associate.type === "NATURAL_PERSON" && !associate.taxNumber) {
                    return true;
                }
            }
        }
        return false;
    }

    onUpdateBalances() {
        this.generateRadicals(); // n1 too
        this.generateAAClassesBalanceSum(); // n1 too
    }

    setBalances(balances) {
        this.balances = balances;
        this.onUpdateBalances();
        for (const sheet of this.bundleSheetsArray) {
            sheet.setRadicals(this.radicals);
        }
    }

    get bundleSheetsArray(): SheetManager[] {
        return Object.values(this.bundleSheets);
    }

    get CVAEsheetsFromBundle(): SheetManager[] {
        return this.bundleSheetsArray?.filter((sheet) =>
            sheet?._form?.form?.name?.startsWith("1330CVA")
        );
    }

    get isBundleIncludedCVAE(): boolean {
        return this.CVAEsheetsFromBundle?.length > 0;
    }

    get isCVAEeligible(): boolean {
        const sheet1330CVA1: SheetManager = this.CVAEsheetsFromBundle?.find(
            (sheet) => sheet._form?.form?.name === "1330CVA1"
        );
        return Spec.getValue(sheet1330CVA1?.fields?.["AB"]) > 0;
    }
}

// type bundle = {
//     id: string,
//     data: any,
//     status: string,
//     date: string,
//     company: { id: string },
//     accountingPeriod: {id: string, start: string, end: string},
//     form: {id: string, cerfaNumber: string, year: string, form: any},
//     bundleSheets: { id: string, data: any, form: {year: string, id: string, cerfaNumber: string, form: any }}
// }

export type GeneralLedgerAccountType = {
    name: string;
    shortName: string;
    balance: number;
    isAbnormal?: boolean;
    anomaly?: string;
};

function sortSharesByDate(shareA, shareB) {
    const dateA = new Date(shareA.date);
    const dateB = new Date(shareB.date);
    if (dateA < dateB) {
        return 1;
    }
    if (dateA > dateB) {
        return -1;
    }
    return 0;
}

type CompanyDetails = {
    id: string;
    activities: Array<{ id: string; name: string; description: string }>;
    legalForm: string;
    startBusinessDate: any;
    subjectToVAT: boolean;
    vatSystem: string;
    name: string;
    address: string;
    addressComplement: string;
    postalCode: string;
    city: string;
    country: string;
};

export function getImportFilesMillesim(yearFromExistingSheet: string): string {
    if (!yearFromExistingSheet) {
        return "2025"; // from April 1st, 2025, french government can receive 2025 bundle cells
    }
    if (+yearFromExistingSheet < 2024) {
        return "2024"; // no import files before 2024
    }
    return yearFromExistingSheet;
}

export function getAccountingPeriodLength(selectedAccountingPeriod: {
    start: Date;
    end: Date;
}): number {
    const start: Date = selectedAccountingPeriod?.start || undefined;
    const end: Date = selectedAccountingPeriod?.end || undefined;
    if (start && end) {
        return Math.round(moment(end).diff(moment(start), "months", true));
    }
    return 0;
}
